/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-09 16:41:54
 * @LastEditTime: 2019-12-19 10:53:49
 * @LastEditTime: 2019-09-09 11:43:43
 * @LastEditors: Please set LastEditors
 */

export default {
  v5: {
    select_files_to_upload: 'Select files to upload',
    my_video_shorts: 'OMAT VIDEO SHORTS',
    see_more: 'Näytä lisää',
    no_shorts_found: 'Ei löytynyt Shorts-videoita',
    shorts: 'Shorts',
    general_information: 'Yleiset tiedot',
    gamification: 'Pelillistäminen',
    click_to_select_files: 'Klikkaa valitaksesi tiedostot',
    selected_files: 'Valitut tiedostot',
    uploaded: 'Ladattu',
    failed: 'Epäonnistui',
    system_will_automatically_analyze_and_select_the_most_relevant:
      'Järjestelmä analysoi automaattisesti ja valitsee organisaatiosi kirjastosta sisällön tarpeisiin parhaiten sopivat asiakirjat.',
    select_from_library: ' Valitse kirjastosta',
    search_document: 'Etsi asiakirjoja...',
    selected: 'Valittu',
    loading_documents: 'Ladataan asiakirjoja...',
    review_generated_content: 'Tarkista luotu sisältö',
    confirm_and_replace_content: 'Vahvista ja korvaa sisältö',
    the_generate_content_will_replace:
      'Luotu sisältö korvaa valittujen sivujen nykyisen tekstin. Jos et halua soveltaa näitä muutoksia, voit palata edelliseen vaiheeseen.',
    pages_to_be_updated: 'Päivitettävät sivut',
    generated_revisions: 'Luodut tarkistukset',
    lesson_preview: 'Luentoesikatselu',
    create_new_folder: 'Luo uusi kansio',
    rename_item: 'Nimeä kohde uudelleen',
    enter_folder_name: 'Syötä kansion nimi:',
    enter_new_name: 'Syötä uusi nimi:',
    folder_name: 'Kansion nimi:',
    new_name: 'Uusi nimi',
    move_items: 'Siirrä kohteita',
    copy_items: 'Kopioi kohteita',
    move_here: 'Siirrä tänne',
    copy_here: 'Kopioi tänne',
    select_destination_library_and_folder: 'Valitse kohdekirjasto ja kansio:',
    items_selected: 'Valitut kohteet',
    version: 'Versio',
    modified_by: 'Muokannut',
    size: 'Koko',
    restore: 'Palauta',
    are_you_sure_you_want_to_restore_this_version:
      'Haluatko varmasti palauttaa tämän version?',
    this_will_replce_the_current_version_with_the_selected_one:
      'Tämä korvaa nykyisen version valitulla versiolla.',
    restore_this_version: 'Palauta tämä versio',
    restore_not_available: 'Palautus ei ole saatavilla',
    version_history: 'Versiohistoria:',
    by_making_items_public:
      'Kun teet kohteet julkisiksi, kaikki voivat nähdä ne. Lue käyttöehdot ennen jatkamista.',
    the_selected_items_will_be_copied:
      'Valitut kohteet kopioidaan julkiseen kirjastoon ja kaikki näkevät ne.',
    the_selected_items_will_be_copied_to_org:
      'Valitut kohteet kopioidaan organisaation kirjastoon ja kaikki organisaation jäsenet näkevät ne.',
    the_selected_items_will_be_copied_to_your_private:
      'Valitut kohteet kopioidaan yksityiseen kirjastoon ja vain sinä näet ne.',
    loading_organization: 'Ladataan organisaation käyttäjiä...',
    click_download_to_view: 'Napsauta Lataa nähdäksesi',
    archive_file: 'Arkistoi tiedosto',
    no_preview_available: 'Esikatselua ei ole saatavilla',
    audit_report: 'Tarkastusraportti',
    audit_type: 'Toimintatyyppi',
    i_agree_to_the_terms_and_conditions: 'Hyväksyn käyttöehdot.',
    this_file_is_indexed_for_ai: 'Tämä tiedosto on indeksoitu tekoälyä varten.',
    file_is_not_indexed_for_ai: 'Tiedostoa ei ole indeksoitu tekoälyä varten.',
    no_users_found: 'Käyttäjiä ei löytynyt',
    no_users_available: 'Käyttäjiä ei ole saatavilla',
    add_people: 'Lisää ihmisiä',
    people: 'Ihmiset',
    access_type: 'Käyttöoikeustyyppi',
    no_group_found: 'Ryhmiä ei löytynyt',
    add_group: 'Lisää ryhmä',
    groups: 'Ryhmät',
    users_top: 'Käyttäjät',
    confirm_delete: 'Vahvista poisto',
    do_you_want_remove: 'Haluatko poistaa',
    form_this_documents_permissions: 'tästä asiakirjan käyttöoikeuksista?',
    no_users_found_in_this_group: 'Tässä ryhmässä ei löytynyt käyttäjiä',
    add_selected_users: 'Lisää valitut käyttäjät',
    choose_users_from_the_list: 'Valitse käyttäjät listalta',
    selected_users: 'Valitut käyttäjät',
    archived: 'Arkistoitu',
    request_approval: 'Pyydä hyväksyntää',
    document_in_review: 'Asiakirjaa tarkastellaan',
    approve: 'Hyväksy',
    reject: 'Hylkää',
    comment: 'Kommentti:',
    enter_your_commit: 'Kirjoita kommenttisi...',
    confirm_cancel: 'Vahvista peruutus',
    upload_3d_zip: 'Lataa 3D Zip',
    delete_items: 'Poista kohteet',
    video_upload_request: 'Videon latauspyyntö',
    reject_video: 'Hylkää video',
    enter_rejection_reason: 'Anna hylkäyksen syy...',
    please_provide_a_reason_for_reejection_this_video:
      'Anna syy videon hylkäämiselle:',
    generate_trivia_with_ai: 'Luo tietovisa tekoälyllä',
    select_category: 'Valitse kategoria:',
    number_of_question: 'Kysymysten määrä',
    generated_questions: 'Luodut kysymykset',
    this_will_clear_all_generate_question:
      'Tämä poistaa kaikki luodut kysymykset. Jatketaanko?',
    sure_delete: 'Haluatko varmasti poistaa?',
    delete_this_question: 'Haluatko varmasti poistaa tämän kysymyksen?',
    loading_quiz: 'Ladataan tietovisaa...',
    creteing_file: 'Luodaan tiedostoa',
    opening_desktop_app: 'Avaa työpöytäsovellus',
    this_folder_is_empty: 'Tämä kansio on tyhjä',
    select_a_competition: 'Valitse kilpailu...',
    activity_badges: 'Aktiviteettimerkit',
    awarded_every_badges:
      'Myönnetään joka 4, 8, 16, 32, 64, 128, 256, 512 kirjautumisen jälkeen',
    learning_badges: 'Oppimismitalit',
    awarded_every_courses:
      'Myönnetään joka 1, 4, 8, 16, 32, 64, 128 suoritetun kurssin jälkeen',
    test_badges: 'Testimerkinnät',
    awarded_every_passes_tests:
      'Myönnetään joka 2, 4, 8, 16, 32, 64, 128, 256 läpäisyn jälkeen',
    assignment_badges: 'Tehtävämitalit',
    awarded_every_passed_assignments:
      'Myönnetään joka 1, 2, 4, 8, 16, 32, 64, 128 suoritetun tehtävän jälkeen',
    perfectionism_badges: 'Täydellisyyden mitalit',
    awarded_every_assignments_with_scrore:
      'Myönnetään jokaisesta 1, 2, 4, 8, 16, 32, 64, 128 tehtävästä tai testistä, joissa pisteet 90%+',
    communication_badges: 'Viestintämitalit',
    awarded_every_topics_or_comments:
      'Myönnetään jokaisesta 2, 4, 8, 16, 32, 64, 128, 256 aiheesta tai kommentista',
    certification_badges: 'Sertifiointimitalit',
    awarded_every_certificates:
      'Myönnetään joka 1, 2, 4, 8, 16, 32, 64, 128 sertifikaatin jälkeen',
    level_name: 'Tason nimi',
    delete_competition: 'Poista kilpailu',
    this_week: 'Tällä viikolla',
    this_year: 'Tänä vuonna',
    make_organization: 'Tee organisaatio',
    no_results_found: 'Ei tuloksia hakusanalla',
    no_items_available: 'Ei kohteita saatavilla',
    help_video: 'Ohjevideot',
    select_a_video_from_the_list:
      'Valitse video listasta aloittaaksesi oppimisen'
  },
  v4: {
    upload_another_file: 'Upload another file',
    all_files_uploaded: 'All files uploaded',
    upload_and_submit: 'Upload & Submit',
    drop_files: 'Vedä ja pudota tiedostot tai valitse ne.',
    duplicate_lessoon: 'Tämä oppitunti on jo olemassa oppituntilistalla.',
    skill_rule_title: 'Kirjoita Skill Journey -otsikko',
    imageCreatorTitle: 'Kuvantekijä',
    isTranslated: 'Käännetty',
    translationCourseDesc:
      'Kurssin kääntäminen saattaa kestää hetken. Kiitos kärsivällisyydestäsi.',
    translateCourseTip:
      'Luo käännetty kurssi muokkaamista varten alkuperäisestä kurssista. Sisältää kaikki oppitunnit ja sivut.',
    translateModalBtn: 'Käännä',
    translationSuccess: 'Kurssi “<0/>” on käännetty onnistuneesti!',
    translatingCourse: 'Kurssia käännetään...',
    translateModalTitle: 'Käännä kurssi',
    translateSelectLang: 'Valitse kieli',
    fileDeleteconfirm:
      'Haluatko varmasti poistaa tämän tiedoston? Tätä toimintoa ei voi peruuttaa.',
    fileDeleteMessage: 'Tiedosto poistettu onnistuneesti.',
    fileDeleteFailedMessage: 'Tiedoston poistaminen epäonnistui!',
    fileDelete: 'Poista tämä tiedosto.',
    certificate_save_btn: 'Lisää todistus',
    maze_path_info: 'Polkua ei löytynyt graafista!',
    file_size_mb: 'Tiedoston koko saa olla korkeintaan 25 Mt!',
    reports: {
      products: 'Tuotteet',
      users: 'Käyttäjät',
      ph_username: 'Etsi käyttäjänimi',
      ph_id: 'Etsi käyttäjä ID',
      ph_email: 'Etsi käyttäjän sähköposti'
    },
    select_upload_section_id: 'Valitse tiedoston osio',
    tags_all: 'Kaikki',
    delete_file_confirm: 'Haluatko varmasti poistaa tämän tiedoston?',
    delete_file_title: 'Poista tiedosto',
    tooltip_publish: 'Julkaise kurssi valitun asetuksen mukaisesti',
    tooltip_save: 'Tallenna nykyiset muutokset ja kurssi',
    tooltip_next: 'Siirry seuraavaan kurssin asetukseen',
    tooltip_finish: 'Tallenna lopulliset muutokset',
    stories_modal: {
      title_upload: 'Lataa tarina',
      title_update: 'Päivitä tarina',
      title_audio: 'Tarinaäänitiedosto',
      btn_upload: 'Lataa',
      btn_update: 'Päivitä',
      btn_close: 'Sulje',
      btn_cancel: 'Peruuta',
      lbl_cover: 'Tarinan kansikuva',
      rule_cover: 'Lataa tarinan kansikuva!',
      lbl_title: 'Tarinaäänitiedoston otsikko',
      rule_title: 'Kirjoita tarinaäänitiedoston otsikko!',
      lbl_description: 'Tarinaäänitiedoston kuvaus',
      rule_description: 'Kirjoita tarinaäänitiedoston kuvaus!',
      lbl_file: 'Lataa tarinaäänitiedosto',
      rule_file: 'Lataa tarinaäänitiedosto!',
      rule_file_type: 'Lataa kelvollinen tarinaäänitiedosto!',
      lbl_select_file: 'Valitse tarinaäänitiedosto',
      msg_valid_file: 'Valitse kelvollinen tarinaäänitiedosto!',
      msg_success: 'Tarinaäänitiedosto ladattu onnistuneesti',
      msg_failed: 'Median tietojen asetuksia ei voitu suorittaa onnistuneesti!',
      msg_error: 'Tiedoston latauksessa tapahtui virhe!'
    },
    audio_modal: {
      title_upload: 'Lataa',
      title_update: 'Päivitä',
      title_audio: 'Äänitiedosto',
      btn_upload: 'Lataa',
      btn_update: 'Päivitä',
      btn_close: 'Sulje',
      btn_cancel: 'Peruuta',
      lbl_cover: 'Äänen kansikuva',
      rule_cover: 'Lataa äänen kansikuva!',
      lbl_title: 'Äänen otsikko',
      rule_title: 'Kirjoita äänen otsikko!',
      lbl_description: 'Äänen kuvaus',
      rule_description: 'Kirjoita äänen kuvaus!',
      lbl_file: 'Lataa äänitiedosto',
      rule_file: 'Lataa äänitiedosto!',
      rule_file_type: 'Lataa kelvollinen äänitiedosto!',
      lbl_select_file: 'Valitse äänitiedosto',
      msg_valid_file: 'Valitse kelvollinen äänitiedosto!',
      msg_success: 'Äänitiedosto ladattu onnistuneesti',
      msg_failed: 'Median tietojen asetuksia ei voitu suorittaa onnistuneesti!',
      msg_error: 'Tiedoston latauksessa tapahtui virhe!'
    },
    info_episode: 'Jakson kansikuva.',
    btn_delete_episode: 'Poista tämä podcast-jakso.',
    btn_edit_marketplace: 'Muokkaa markkinapaikan tietoja.',
    btn_save_marketplace: 'Tallenna nykyiset muutokset.',
    btn_ai_podcast: 'Luo podcast-jakso tekoälyn avulla.',
    btn_upload_podcast: 'Lataa oma podcast-äänijakso.',
    attach_file: 'Lataa tiedosto ja jaa sisältö yleisösi kanssa',
    fileDownload: 'Lataa tämä tiedosto',
    singleEpishode: 'Jakso',
    podcast_music: 'Podcastit, musiikki & tarinat',
    publishHeader: 'Julkaise Podcastit, musiikki & tarinat',
    editHeader: 'Muokkaa Podcastia, musiikkia & tarinoita',
    createHeader: 'Luo Podcast, musiikki & tarinat',
    marketplaceHeader: 'Podcastin, musiikin & tarinoiden markkinapaikka',
    message_marketplace: 'Täytä markkinapaikan lomake huolellisesti!',
    create_podcast_live: 'Live Podcastit ja musiikki',
    create_podcast_custom: 'Mukautetut podcastit ja musiikki',
    create_podcast_stories: 'Tarinat',
    ai_Assisted_podcast_reation:
      'AI-avusteinen podcastien ja musiikin luominen',
    publishTitle:
      'Julkaise podcastit, musiikki & tarinat ja jaa ne maailmalle.',
    customButton: 'Luo mukautettu',
    customTitle: 'Tallenna muutokset podcastiin.',
    updateButton: 'Päivitä',
    createButton: 'Luo',
    createNewButton: 'Luo uusi',
    updateTitle: 'Muokkaa nykyisiä Podcast-, musiikki- & tarinatietoja.',
    createTitle: 'Luo uusi Podcast, musiikki & tarina.',
    createNewTitle: 'Luo uusi Podcast, musiikki & tarina nykyisillä tiedoilla.',
    podcastTitle: 'Jaksolista',
    podcastStoryTitle: 'Tarinajaksolista',
    podcastToolTipTitle: 'Podcast-jaksolista',
    uploadAudio: 'Lataa',
    aiAudio: 'AI-ääni',
    emptyPodcast: 'Podcastit, musiikki & tarinat eivät ole vielä saatavilla.',
    emptyStoriesPodcast: 'Tarinoita ei ole vielä lisätty.',
    emptyCreatePodcast: 'Luo podcast lisätäksesi ääntä.',
    playPodcast: 'Toista valittu podcast, musiikki & tarina.',
    pausePodcast: 'Pysäytä valittu podcast, musiikki & tarina.',
    selectPodcast: 'Valitse tämä podcast, musiikki & tarina.',
    downloadPodcast: 'Lataa tämä äänitiedosto.',
    uploadAudioFile: 'Lataa uusi ja korvaa nykyinen ääni.',
    deleteConfirm: 'Haluatko varmasti poistaa tämän äänen?',
    roomName: 'Podcastin nimi',
    addGuestTitle: 'Lisää vierailevia esiintyjiä',
    showTime: 'Näyttöaika',
    startTime: 'Aloitusaika',
    endTime: 'Lopetusaika',
    erorMsgImg: 'Valitse kelvollinen kuva.',
    failedMsgImg: 'Kuvan lataus epäonnistui, yritä uudelleen!',
    failedMsgUpload: 'Kansikuvan lataus epäonnistui!',
    btnCoverUpload: 'Lataa kansikuva',
    is_private: 'Yksityinen',
    to_attach: 'Liitä tiedosto',
    file_attached: 'Liitetty tiedosto(t)',
    main_event: 'Päätapahtuma',
    event: 'Tapahtumat',
    upload_pdf: 'Lataa PDF',
    portrait: 'Pysty',
    landscape: 'Vaaka',
    import_from_library: 'Tuo teksti mediakirjastosta',
    question_answer_ai: 'Kysymys/Vastaus AI',
    take_maze: 'OTA MetaMaze',
    training: 'Koulutus',
    select_transcribe_locale: 'Valitse kielen transkriptioon',
    transcribe_limit: 'Syötä transkriptioajat',
    not_complete: 'Markkinapaikan tiedot eivät ole täydelliset',
    complete: 'Markkinapaikan tiedot ovat täydelliset',
    not_admin: 'Julkaisu markkinapaikalle vaatii ylläpitäjän oikeudet',
    no_course: 'Ota otsikko ja valitse kuva aktivoidaksesi markkinapaikan',
    scorm_not_complete:
      'Ota otsikko ja valitse kuva ladataksesi SCORM-tiedoston',
    not_found_maze: 'MetaMazea ei löydy',
    email_require: 'Sähköpostit ovat pakollisia',
    poll_required: 'Kyselytiedot ovat pakollisia',
    alert: 'Varoitus!',
    warning: 'Varoitus!',
    ok: 'OK',
    cancel: 'Peruuta',
    done: 'Valmis',
    insert: 'Lisää',
    private: 'Yksityinen',
    public: 'Julkinen',
    no_connection: 'Internet-yhteys katkennut',
    switch: 'Vaihda',
    share_screen: 'Jaa näyttö',
    stop_share_screen: 'Lopeta näytön jakaminen',
    share_screen_with_camera: 'Jaa näyttö kameran kanssa',
    stop_share_screen_with_camera: 'Lopeta näytön jakaminen kameran kanssa',
    camera_on: 'Kamera päälle',
    camera_off: 'Kamera pois päältä',
    mic_on: 'Mykistä pois',
    mic_off: 'Mykistä',
    fullscreen: 'Koko näyttö',
    live_now: 'Lähetys käynnissä',
    schedule_on: 'Aikatauluta',
    organisations: 'Organisaatiot',
    org_groups: 'Organisaatioryhmät',
    specific_user: 'Tarkoitettu käyttäjä',
    gif: 'GIF',
    unavailable: 'Ei saatavilla',
    yes: 'Kyllä',
    no: 'Ei',
    event_duration_message: 'Enintään 300 minuuttia (5 tuntia)',
    send_email: 'Lähetä sähköpostiviesti',
    admin_only: 'Vain ylläpitäjät',
    join: 'Liity',
    leave: 'Poistu',
    share: 'Jaa',
    share_text:
      'Kirjoita sähköpostiosoite, jolle haluat jakaa tämän tiedoston.',
    share_text_title: 'Jaa PDF',
    share_text_title_txt: 'Jaa teksti',
    select_users: 'Valitse käyttäjät',
    delete: 'Poista',
    attachment_event: 'Tapahtuman liitteet:',
    transcribe_limit: 'Transkriptioajan raja',
    monthly_transcribe: 'Kuukausittainen transkriptioraja:',
    enable_ai: 'Ota AI käyttöön:',
    enable_maze: 'Ota MetaMaze käyttöön:',
    media_service: 'Mediapalvelu',
    allow_others: 'Salli muiden muokata',
    join_breakout_room: 'Liity breakout-huoneeseen',
    bio: 'Esittely',
    linkedin: 'LinkedIn',
    select_org_report: 'Valitse organisaatio raportin luomiseksi.',
    org_image_not_found: 'Kuvaa ei löydy',
    insert_text: 'Lisää teksti',
    insert_question_answer: 'Kysymys/Vastaus AI',
    modal_title2: 'Tekstigalleria',
    my_text_library: 'Oma tekstikirjasto',
    ai: 'AI',
    public_text_library: 'Julkinen tekstikirjasto',
    organization_text_library: 'Organisaation tekstikirjasto',
    no_transcribed_text: 'Ei transkriboituja tekstejä',
    public_text_not_found: 'Julkista transkriboitua tekstiä ei löytynyt',
    org_text_not_found: 'Organisaation transkriboitua tekstiä ei löytynyt',
    org_video_not_found: 'Videota ei löytynyt',
    canva: 'Tee se Canvalla',
    canva_open: 'Klikkaa tästä avataksesi Canva-editorin.',
    pdf: 'PDF',
    txt: 'Teksti',
    human: 'Premium',
    shared_file: 'Tiedosto on jaettu onnistuneesti.',
    error_shared_file: 'Tiedoston jakamisessa tapahtui virhe. Yritä uudelleen.',
    publish: 'Julkaise',
    maze_scenes: 'MetaMaze kohtaukset',
    pexel_images: 'Pexel kuvat',
    group: 'Ryhmä',
    group_name: 'Ryhmän nimi',
    select_group: 'Valitse ryhmä',
    search_maze: 'Etsi MetaMaze',
    hosts: 'Isännät',
    avg_score: 'Keskimääräinen pisteet (%)',
    maze_report: 'MetaMaze-raportti',
    maze_view: 'Näytä MetaMaze',
    title_maze: 'MetaMaze',
    author: 'Tekijä',
    match: 'Vastaavuus',
    preview_mazeTitle: 'Otsikko: ',
    other: 'Muu',
    total: 'Yhteensä',
    report_course: 'Kurssi',
    report_courses: 'Kurssit',
    report_event: 'Tapahtuma',
    report_events: 'Tapahtumat',
    report_maze: 'Labyrintti',
    report_personalize_learning: 'Yksilöllinen oppiminen',
    report_live_assessment: 'Live-arviointi',
    report_live_assessments: 'Live-arvioinnit',
    report_skill_journey: 'Taitojen matka',
    skill_journey: 'Taitojen matka',
    skill_journeys: 'Taitojen matkat',
    date: 'Päivämäärä: ',
    search_people: 'Etsi ihmisiä',
    passed: 'Hyväksytty',
    failed: 'Hylätty',
    item: 'Kohde',
    type: 'Tyyppi',
    minimum_pass_score: 'Vähimmäispistemäärä läpäisyyn',
    resources_count: 'Resurssien määrä',
    back: 'Takaisin',
    resources: 'Resurssit',
    time_spent: 'Käytetty aika (min)',
    detail: 'Yksityiskohdat',
    watched_time_mins: 'Katseluaika (min)',
    personalize_learning: 'Yksilöllinen oppiminen',
    result: 'Tulos',
    assessment_title: 'Otsikko',
    marketPlace_graph: 'Marketplace-kaavio',
    attachments: 'Liitteet',
    new_scorm_course: 'Luo uusi SCORM-kurssi',
    upload_scorm_course: 'Lataa SCORM-kurssi',
    new_maze: 'Luo uusi MetaMaze',
    new_skill_journey: 'Luo uusi taitojen matka',
    tags_scorm: 'SCORM',
    tags_skillJourney: 'Taitojen matka',
    new_discussion_room: 'Luo uusi podcast',
    title: 'Mitä haluat tehdä tänään?',
    build_course: 'Rakenna oma kurssini',
    live_broadcast: 'Live-lähetys',
    invite_users: 'Kutsu käyttäjiä organisaatiooni',
    build_voice_over: 'Luo oma ääni',
    view_reports: 'Näytä raportit',
    upload_media: 'Lataa mediaa / tehtäviä ja jaa',
    main_menu: 'Päävalikko',
    get_started: 'Aloita',
    search_group: 'Etsi organisaatioryhmä',
    ai_course: 'AI-kurssi',
    search_user: 'Etsi yrityksen nimi',
    no_maze: 'Ei yhtään MetaMazeja saatavilla',
    conference_event_title: 'Konferenssitapahtumat',
    conference_event_subTitle: 'Päättyneet konferenssitapahtumat',
    conference_event: 'Ei konferenssitapahtumia tällä hetkellä',
    no_skill: 'Ei taitojen matkoja saatavilla',
    no_podcast: 'Ei podcasteja saatavilla',
    maze_channel: 'MetaMaze',
    past_live_assessment: 'Menneet live-arvioinnit',
    no_live_assessment: 'Ei live-arviointeja saatavilla',
    enrolled_courses: 'Kurssit',
    my_video_channel: 'Omat videokanavat',
    enrolled_liveEvents: 'Live-tapahtumat',
    sharebot: 'Sharebot',
    selected_language: 'Valittu kieli',
    shareSphere_game: 'ShareSphere-peli',
    maze: 'MetaMaze',
    skill: 'Taitojen matka',
    channel: 'Kanava',
    order: 'Tilaus',
    is_record: 'Tallenna',
    no_maze_found: 'MetaMazeja ei löytynyt',
    maze_self_limit_reached: 'Olet ylittänyt itseopiskelun MetaMaze-rajan',
    metamaze_two_times: 'Olet jo suorittanut tämän MetaMaze-tehtävän kahdesti',
    metamaze_two_times_no_result:
      'Olet suorittanut tämän MetaMaze-tehtävän kahdesti. Kolmannesta kerrasta alkaen tuloksia ei tallenneta.',
    scorm_zip: 'SCORM-ZIP',
    pass_score: 'Hyväksymispistemäärä',
    organization: 'Valitse organisaatio',
    pass_score_mark: 'Syötä pistemäärä välillä 1-100',
    maze_cloning_success: 'MetaMaze "<0/>" kloonattiin onnistuneesti!',
    create_certificate: 'Luo todistus',
    create_badge: 'Luo merkki',
    certificate_added: 'Todistus lisätty',
    badge_added: 'Merkki lisätty',
    certificate_warning:
      'Todistusta/merkkiä ei voi enää muokata julkaisun jälkeen!',
    created_course_plan: 'Muokkaa kurssiasi ja järjestä live-tapahtumia',
    market_place_space: 'Markkinapaikka',
    select_course_language: 'Valitse kieli (valinnainen)',
    select_language: 'Valitse kieli',
    file_upload: 'Lataa tiedosto',
    text: 'Kirjoita teksti tähän...',
    attempts_count: 'Käyttäjä voi suorittaa vain kerran',
    no_of_people_placeholder: 'Henkilömäärä',
    back_to_maze: 'Takaisin MetaMazeen',
    edit_maze: 'Muokkaa MetaMaze',
    wait: 'Odota...',
    retry: 'Yritä uudelleen',
    publish_scorm_course: 'Julkaise SCORM-kurssi',
    publish_maze: 'Julkaise MetaMaze',
    import: 'Tuo sisältöjä',
    answer_correct: 'Valitse oikea vastaus',
    author_name: `Anna kirjoittajan nimi`,
    select_category: 'Valitse kategoria',
    course_outline: 'Lisää kurssin sisältö',
    course_obj: 'Lisää kurssin tavoitteet',
    course_description: 'Lisää kurssin kuvaus',
    maze_outline: 'Lisää labyrintin sisältö',
    maze_obj: 'Lisää labyrintin tavoitteet',
    maze_description: 'Lisää labyrintin kuvaus',
    lessons: 'Lisää oppituntien määrä',
    user_email_require: `Käyttäjän sähköposti vaaditaan`,
    team_size: `Lisää tiimin koko`,
    enter_price: 'Syötä hinta (vähintään 5)',
    input_title_maze: 'Lisää labyrintin otsikko',
    trainer_bio: 'Lisää kouluttajan esittely',
    trainer_linkedin: 'Lisää kouluttajan LinkedIn',
    error_video: 'Lisää videoiden määrä',
    input_video_link: 'Lisää videolinkki',
    number_of_video: 'Videoiden määrä',
    number_of_lessions: 'Oppituntien määrä',
    no_of_people_in_conference: 'Kuinka monta ihmistä kokouksessa?',
    transcribe_settings: 'Tekstitysasetukset',
    transcribe: 'Tekstitys',
    cloning_maze: 'MetaMaze kloonataan...',
    id_number: 'ID-numero',
    timezone: 'Aikavyöhyke',
    edit_maze: 'Muokkaa',
    delete_maze: 'Poista',
    view_maze: 'Katso',
    create_metamaze: 'Luo uusi MetaMaze',
    metamaze_scenario: 'MetaMaze-skenaario',
    publish_metamaze: 'Julkaisuasetukset',
    search_result: 'Hakutulokset:',
    search_for: 'Etsi',
    search_no_result: '- Ei tuloksia!',
    channel_no_available: 'Kanavaa ei ole saatavilla!',
    this_card: 'Tämä on kortti',
    course_no_available: 'Kursseja ei ole saatavilla!',
    exit_fullscreen: 'Poistu koko näytöstä',
    bg_image: 'Taustakuva',
    introduction: 'Johdanto',
    summary: 'Yhteenveto',
    generate_introduction: 'Luo johdanto',
    generate_summary: 'Luo yhteenveto',
    bullet_points: 'Luettelomerkit',
    title_simulation: 'Lisää simulaation otsikko',
    view_generated_images: 'Katso luodut kuvat',
    image_transparency: 'Kuvan läpinäkyvyys',
    template_bg_color: 'Mallipohjan taustaväri',
    select_template_layout: 'Valitse mallipohjan asettelu',
    reload_template: '(Lataa mallipohjat uudelleen)',
    are_you_sure_want_close: 'Haluatko varmasti sulkea?',
    all_your_changes_will_be_lost: 'Kaikki muutoksesi katoavat.',
    please_checked_before_generated_video:
      'Varmista, että kaikki on kunnossa ennen videon luomista',
    voice_must_be_selected: 'Ääni pitää valita',
    avatar_must_be_selected: 'Avatar pitää valita',
    maximum_five_slides_try_again:
      'Virhe kuvien poimimisessa tiedostosta. Tiedostossa saa olla enintään 5 diaa, ja jokaisella dialla tulee olla muistiinpanot. Yritä uudelleen.',
    back_to_upload: 'Takaisin lataukseen',
    uploading_file_to_server: 'Ladataan tiedostoa palvelimelle',
    extracting_images_from_your_file: 'Poimitaan kuvia tiedostosta',
    upload_your_ppt_or_drag:
      'Lataa PowerPoint (.PPTX) -tiedostosi tai vedä se tähän',
    maximum_five_slides_error:
      'PowerPoint-tiedostossa saa olla enintään 5 diaa, ja jokaisella dialla tulee olla muistiinpanot. Muuten virhe.',
    number_of_questions_generated: 'Luotavien kysymysten määrä',
    quiz_page_this_cannot_be_done:
      'Oletko varma, että haluat lisätä tietovisan tälle sivulle? Tätä ei voi peruuttaa.',
    confirm_selection: 'Vahvista valinta',
    select_quiz_page: 'Valitse tietovisaan sivu',
    lesson_do_you_want_add_this_quiz:
      'Mihin kohtaan oppituntia haluat lisätä tämän tietovisan?',
    beginning_of_lesson: 'Oppitunnin alkuun',
    end_of_lesson: 'Oppitunnin loppuun',
    currently_active_page: 'Nykyinen aktiivinen sivu',
    finish: 'Valmis',
    upload_selection_file: 'Lataa osiotiedosto',
    general_quiz: 'Yleinen tietovisa',
    manage_sequence: 'Hallitse järjestystä',
    save_sequence: 'Tallenna järjestys',
    new: 'Uusi',
    in_progress: 'Käynnissä',
    recommended_course: 'Suositellut kurssit',
    up_coming: 'Tulossa pian',
    past_live: 'Menneet live-tilaisuudet',
    input_your_channel_name: 'Anna kanavasi nimi',
    organization_place: 'Organisaation markkinapaikka',
    marketplace_report: 'Markkinapaikan raportti',
    story_writing: 'Tarinoiden kirjoittaminen',
    Ai_quiz: 'AI-tietovisa',
    generate_quiz: 'Luo tietovisa',
    create_story: 'Luo tarina',
    change_layout_page: 'Haluatko vaihtaa tämän sivun asettelua?',
    change_layout_message:
      'Tekstit, kuvat, tausta ja logo säilytetään, mutta muu sisältö poistetaan.',
    reviews: 'Arvostelut',
    tab_attachments: 'Liitteet',
    zoom_in: 'Lähennä',
    zoom_out: 'Loitonna',
    zoom_reset: 'Nollaa zoomaus',
    no_attachment: 'Ei liitteitä',
    select_upload_simulation: 'Valitse tai lataa simulaatio',
    quiz_updated_successfully: 'Tietovisa päivitetty onnistuneesti!',
    quizes: 'Tietovisat',
    trivia: 'Trivia',
    closing: 'Suljetaan...',
    products: 'Tuotteet',
    ask_questions: 'Kysy kysymys tästä...',
    course_information: 'Kurssin tiedot',
    course_assistance: 'Kurssin tekijän apu',
    go_back: 'Palaa takaisin',
    ai_generate_content_progress: 'Sisällön luonti käynnissä',
    view_generate_content: 'Katso luotu sisältö',
    generate_error: 'Luontivirhe!',
    confirm_creating_course:
      'Haluatko varmasti luoda kurssin tällä sisällöllä?',
    generate_content_automatically:
      'Kaikki luodut sisällöt lisätään automaattisesti kurssin oppitunteihin ja sivuihin.',
    quiz_created_successfully: 'Tietovisa luotu onnistuneesti!',
    create_quiz: 'Luo tietovisa',
    quiz_setting: 'Tietovisan asetukset',
    please_fill_quiz_setting: '* Täytä kaikki tiedot tietovisan asetuksissa',
    question_list: 'Kysymyslista',
    add_quiz_to_page: 'Lisää tietovisa sivulle',
    form_create_question: 'Luo kysymyslomake',
    user_information_updated: 'Käyttäjätiedot päivitetty!',
    your_stripe_activete_to_continue:
      'Stripe-tili ei ole aktiivinen. Jatka yhdistämällä tai aktivoimalla se.',
    connect_tripe: 'Yhdistä Stripe',
    certificate_sent_sucessfully:
      'Todistus lähetetty onnistuneesti sähköpostiisi.',
    error_try_again: 'Virhe, yritä uudelleen!',
    error_delete_channel: 'Kanavan poistossa tapahtui virhe.',
    error_update_sub: 'Tilauspäivityksessä tapahtui virhe.',
    end_time_cannot_start: 'Lopetusaika ei voi olla ennen aloitusaikaa.',
    start_date_time_interval: 'Aloituspäivämäärä ja -aika vaaditaan!',
    podcast_updated_successful: 'Podcast päivitetty onnistuneesti.',
    podcast_created_successful: 'Podcast luotu onnistuneesti.',
    podcast_published_successful: 'Podcast julkaistu onnistuneesti.',
    podcast_cover_updated: 'Podcastin kansikuva päivitetty.',
    new_podcast_details:
      'Luo uusi podcast nykyisellä podcastilla ja uusilla yksityiskohdilla.',
    current_update_podcast: 'Päivitä nykyinen podcast musiikilla ja tarinalla.',
    create_new_podcast: 'Luo uusi podcast',
    publish_podcast_public_view: 'Julkaise podcast yleisölle',
    only_allowed_twenty_five_email: 'Sallitut enintään 25 sähköpostiosoitetta',
    only_allowed_five_email: 'Sallitut enintään 5 sähköpostiosoitetta',
    cover_is_required: 'Kansikuva on pakollinen',
    topic_is_required: 'Aihe on pakollinen',
    delete_schedule: 'Poista aikataulu',
    make_as_coaching: 'Merkitse valmennukseksi',
    manage_category: 'Hallitse kategoriota',
    threshold: 'Kynnysarvo',
    threshold_popup:
      'Kynnysarvo (prosentteina), jolla aloitetaan suositukset tälle kategorialle',
    list_of_catagory: 'Kategoriat',
    category_name: 'Kategorian nimi',
    category_threshold: 'Kategorian kynnysarvo',
    play_game: 'Pelaa peliä',
    switching_organization: 'Vaihdetaan organisaatiota...',
    coaching_session: 'Valmennussessio',
    required_channel_id: 'Kanava-ID vaaditaan!',
    error_occured_try_again: 'Virhe tapahtui. Yritä uudelleen!',
    please_complete_marketplace_form: 'Täytä markkinapaikan lomake!',
    upload_file_corrupt: 'Ladattu tiedosto on vioittunut.',
    course_not_published: 'Kurssia ei ole vielä julkaistu!',
    error_request: 'Virhe pyynnössä. Yritä uudelleen!',
    skill_request: 'Täytä puuttuvat kentät!',
    error_occured: 'Virhe tapahtui. Yritä uudelleen!',
    show_time: 'Näytä aika',
    start_time: 'Aloitusaika',
    end_time: 'Lopetusaika',
    room_name: 'Podcastin nimi',
    add_guest_speaker: 'Lisää vierasesiintyjä',
    cover_picture: 'Kansikuva',
    guest_speaker: 'Vierasesiintyjät',
    see_more: 'Näytä lisää',
    see_less: 'Näytä vähemmän',
    background: 'Tausta',
    icon: 'Ikoni',
    icon_size: 'Ikonin koko',
    icon_color: 'Ikonin väri',
    only_text: 'Teksti',
    change_bg: 'Vaihda taustaväri',
    bg_color: 'Taustaväri',
    font_size: 'Fonttikoko',
    normal: 'Normaali',
    change_color: 'Vaihda tekstin väri',
    slant_text: 'Kallistettu teksti',
    text_radius: 'Tekstin säde',
    vertical_align: 'Pystysuunta',
    horizontal_align: 'Vaakasuuntainen tasaus',
    change_icon_color: 'Vaihda ikoninväriksi',
    upload_icon: 'Lataa ikoni',
    upload_signature: 'Lataa allekirjoitus',
    add_another_sign: 'Lisää toinen allekirjoitus',
    name_badges: 'Merkkien nimet',
    should_less_150: 'pitää olla 150 merkkiä tai vähemmän',
    your_badge: 'Sinun merkki',
    do_you_want_delete_badge: 'Haluatko varmasti poistaa tämän merkin?',
    do_you_want_delete_cert: 'Haluatko varmasti poistaa tämän sertifikaatin?',
    upload_logo: 'Lataa logo',
    name_of_cert: 'Sertifikaatin nimi',
    upload_cert: 'Päivitä sertifikaatti',
    your_cert: 'Sinun sertifikaatti',
    translate_to: 'Käännä kielelle',
    select_file_attach: 'Valitse liitettävä tiedosto',
    certificate: 'Sertifikaatti',
    badge: 'Merkki',
    publish_options: 'Julkaisuvaihtoehdot',
    publish_skills_journey: 'Julkaise taitopolku',
    videos: 'Videot',
    generate_ai_video:
      'Videon generointiprosessi voi kestää hetken. Saat sähköpostitse ilmoituksen, kun se on valmis.',
    trainer_information: 'Kouluttajan tiedot',
    promotional_video_link: 'Mainosvideon linkki',
    please_select: 'Valitse',
    image_name: 'Kuvan nimi:',
    image_size: 'Kuvan koko:',
    charecters_fifteen_less: '15 merkkiä tai vähemmän',
    leadership: 'Johtajuus',
    text_arc: 'Tekstin kaari',
    vertical: 'Pysty',
    horizontal: 'Vaaka',
    badge_history: 'Merkkien historia',
    templates: 'Mallipohjat',
    sign: 'Allekirjoitus',
    logo: 'Logo',
    certificate_history: 'Sertifikaattihistoria',
    please_wait: 'Odota hetki...',
    information: 'Tietoa',
    support_five_thousand_live_event:
      'Tukee jopa 5000 osallistujaa tapahtumassa',
    support_ten_live_event: 'Tukee jopa 10 livevideon osallistujaa',
    we_will_back_participant:
      'Palaamme tapahtuman kanssa, jossa on paljon osallistujia.',
    course_objectives: 'Kurssin tavoitteet',
    course_outlines: 'Kurssin sisältö',
    price_dollor: 'Hinta (USD)',
    not_completed: 'Ei valmis',
    enable_marketplace: 'Ota markkinapaikka käyttöön',
    enable_course_ai: 'Ota AI-kurssin luominen käyttöön',
    enable_report_to_admin: 'Ota raportointi ylläpitäjälle käyttöön',
    enable_white_label: 'Ota valkoinen merkki käyttöön',
    enable_eleven_labs_for_maze_play:
      'Ota Elevenlabs käyttöön Maze Play -toiminnossa',
    enable_eleven_labs_for_maze_play_cloned:
      'Ota käyttöön Elevenlabs kloonatut äänet',
    not_completed: 'Ei valmis',
    simulation_quiz: 'Simulaatiokyselyt',
    bg_color_setting: 'Taustavärin asetukset',
    color_preview: 'Väriesikatselu',
    choose_new_color: 'Valitse uusi väri',
    remove_color: 'Poista väri',
    apply_color: 'Käytä väriä',
    elemeent_in_a_sceenario_page:
      'Et voi lisätä muita elementtejä haaste-sivulle. Yritä muilla sivuilla tai poista haaste sivulta.',
    no_data_found: 'Tietoja ei löytynyt',
    references: 'Viitteet',
    open_file: 'Avaa tiedosto',
    showing_result: 'Näytetään tulokset:',
    fiften_day_free_trail: '15 päivän ilmainen kokeilu',
    your_browser_does_not_support: 'Selain ei tue ääntä.',
    podcast_desc: 'Podcast-kuvaus',
    input_podcast_desc: 'Anna podcast-kuvaus',
    podcast_obj: 'Podcast-tavoitteet',
    input_podcast_obj: 'Anna podcast-tavoitteet',
    podcast_outline: 'Podcast-käsikirjoitus',
    input_podcast_outline: 'Anna podcast-käsikirjoitus',
    add_file: 'Lisää tiedosto',
    generate_podcast_audio: 'Luo podcast-ääni',
    generate_uploaded_file_input_parameter:
      'Luodaan sisältöä ladattujen tiedostojen perusteella.',
    go_backe_generation_state: 'Palaa sisällönluonnin tilaan',
    create_ai_powered_podcast: 'Luo AI-pohjaisia podcast-jaksoja',
    generate_voice_for_all_podcast: 'Luo ääni kaikille podcast-jaksoille',
    create_podcast_episode: 'Luo podcast-jakso',
    voice_name: 'Äänen nimi',
    input_custom_name: 'Anna mukautettu nimi!',
    enter_custom_name: 'Syötä mukautettu äänen nimi',
    upload_complete: 'Lataus valmis',
    uploading_in_progress: 'Lataus käynnissä...',
    podcast_stream_content: 'Podcast-sarjan sisältö',
    upload_podcast_cover: 'Lataa podcastin kansikuva!',
    enter_podcast_name: 'Anna podcastin nimi!',
    podcast_topic: 'Podcast-aihe',
    enter_podcast_topic: 'Anna podcast-aihe!',
    enter_podcast_desc: 'Anna podcast-kuvaus!',
    number_of_speaker: 'Puhujien määrä',
    select_the_number_of_speaker: 'Valitse puhujien määrä!',
    number_of_episode: 'Jaksojen määrä',
    input_number_of_episode: 'Anna jaksojen määrä!',
    podcast_length: 'Podcastin pituus',
    select_the_podcast_length: 'Valitse podcastin pituus!',
    short_podcast: 'Lyhyt (5-10 minuuttia)',
    medium_podcast: 'Keskipitkä (15-18 minuuttia)',
    long_podcast: 'Pitkä (18 minuuttia tai enemmän)',
    name_of_host: 'Isännän nimi',
    enter_host_name: 'Anna isännän nimi!',
    guest_name: 'Vieraiden nimet',
    enter_guest_name: 'Anna vieraiden nimet!',
    choose_speaker_tone: 'Valitse puhujan sävy',
    enter_speaker_tone: 'Valitse podcastin äänen sävy!',
    informal: 'Epäsovinnainen',
    formal: 'Virallinen',
    serious: 'Vakava',
    light_humor: 'Kevyt huumori',
    casual: 'Rentoa',
    select_content_source: 'Valitse sisällön lähde',
    from_internet: 'Internetistä',
    upload_pdf_internet: 'Lataa PDF tai sisällön sivu',
    note: 'Huomautus:',
    podcast_content_will_be_automatically_generated:
      'Podcastin sisältö luodaan automaattisesti luotettavista internetlähteistä.',
    upload_or_select_file: 'Lataa tai valitse tiedosto(t)!',
    podcast_eposode_title: 'Podcast-jakson otsikko',
    enter_podcast_title: 'Anna jakson otsikko!',
    podcast_episode_des: 'Podcast-jakson kuvaus',
    enter_podcast_episode_des: 'Anna jakson kuvaus!',
    voice: 'Ääni',
    music: 'Musiikki',
    select_music: 'Valitse musiikki',
    play_the_music: 'Soita musiikkia',
    stop_the_music: 'Pysäytä musiikki',
    context: 'Sisältö',
    generate_audio_content_selected_voice: 'Luo ääni valitulla äänellä.',
    required_field_before_submitting:
      'Täytä kaikki pakolliset kentät ennen lähettämistä.',
    regenerate_voice: 'Luo ääni uudelleen',
    generate_voice: 'Luo ääni',
    your_browser_does_not_suppot: 'Selain ei tue ääntä.',
    are_sure_leave_podcast: 'Oletko varma, että haluat poistua podcastista?',
    broadcast_ongoing:
      'Lähetys on käynnissä. Haluatko varmasti poistua tältä sivulta?',
    brodcaster_unavailable: 'Lähettäjä ei ole saatavilla.',
    setting_calender_for_booking: 'Varaa kalenteri',
    add_calender: 'Lisää kalenteri',
    waiting_join_host: 'Odotetaan isännän liittymistä...',
    no_reviews_found: 'Arvosteluja ei löytynyt',
    rated_already: 'Olet jo arvostellut tämän suoran lähetyksen',
    downlink_png: 'Lataa PNG-muodossa',
    downlink_jpg: 'Lataa JPG-muodossa',
    donwload_file_format: 'Valitse ladattavan tiedoston muoto.',
    crashed_event:
      'Tapahtuma keskeytettiin. Uuden tapahtuman luominen on tarpeen. Pahoittelemme häiriötä.',
    prompt: 'Kehoitus:',
    generated_image: '🚀 Kuvan luonti käynnissä... Odota hetki.',
    download_add: 'Lataa kaikki',
    setting_generator: 'Generaattorin asetukset',
    enter_image_prompt: 'Anna kuvauksen aihe',
    image_prompt: 'Kuvauksen aihe',
    negative_prompt: 'Ei-toivottu sisältö',
    negative_image_prompt: 'Ei-toivottu kuvauksen aihe',
    number_output: 'Tulostettavien kuvien määrä',
    enter_number_output: 'Anna tulostettavien kuvien määrä',
    image_style: 'Kuvan tyyli',
    output_format: 'Tulostusmuoto',
    seeds: 'Siemenet',
    enter_seeds: 'Anna siemenet',
    performance_mode: 'Suorituskykymoodi',
    quality: 'Laatu',
    speed: 'Nopeus',
    balanced: 'Tasapainotettu',
    guidance_scale: 'Ohjausaste',
    enter_guidance: 'Anna ohjausaste',
    select_image: 'Valitse kuva.',
    image_prmt: 'Kuvauksen aihe',
    generate_image_list_empty: 'Luodut kuvat eivät ole käytettävissä.',
    knowledge_center_tooltrip_des:
      'Saat tarkkoja ja asiaankuuluvia vastauksia internetistä kerätyn tiedon perusteella. AI-malli perustuu ladattuihin internetteksteihin.',
    contexts: 'Sisällöt',
    ai_processing_video_sharebot:
      'Sharebotin videoiden AI-käsittely on voimassa vain 24 tuntia.',
    remove_sharebot_video: `Jos haluat poistaa Sharebot-edustavan videon, poista äänileike ja video.`,
    remove_sharebot_video_audio:
      'Äänileikkeen poistaminen poistaa Sharebot-linkityksen videosta/äänestä, mutta video pysyy mediakirjastossa/kanavalla.',
    monthly_live_stream:
      'Ota yhteyttä kuukausittaisten suoratoistorajoitusten muuttamiseksi.',
    monthly_transcribe_limit:
      'Ota yhteyttä kuukausittaisten puheentunnistusrajoitusten muuttamiseksi.',
    must_be_one_to_three_hundred: 'Arvon tulee olla välillä 1–300 minuuttia.',
    all_field_required: 'Kaikki kentät ovat pakollisia.',
    duration_minute: 'Kesto (max 300 minuuttia)',
    gender: 'Sukupuoli',
    select_gender: 'Valitse sukupuoli',
    accent: 'Korostus',
    select_accent: 'Valitse korostus',
    create_voice: 'Luo ääni',
    enter_voice_name: 'Syötä äänen nimi',
    select_voice_gender: 'Valitse äänen sukupuoli',
    upload_voice: 'Lataa oma äänesi',
    upload_voice_mp_three: 'Lataa oma äänesi (.mp3)',
    cloned_voice: 'Kopioitu ääni',
    voice_type: 'Äänen tyyppi',
    select_voice_type: 'Valitse äänen tyyppi',
    sharelook_stand: 'Vakioversio',
    sharelook_premium: 'Premium',
    sharelook_custum_voice: 'Mukautettu (kloonattu ääni)',
    create_auto_flow: 'Luo automaattinen kulku',
    how_many_layers: 'Kuinka monta tasoa',
    verify_selection: 'Vahvista valinta',
    uploaded_successful: 'Lataus onnistui',
    upload_failed: 'Lataus epäonnistui',
    upload_only_five_mb: 'Lataa sisältö (PDF-tiedosto, enintään 5 tiedostoa)',
    docs_from_org_library: 'Asiakirjat organisaation kirjastosta',
    failed_maze_generate: 'Labyrintin luominen epäonnistui. Yritä uudelleen.',
    generate_metamaze: 'Luodaan MetaMaze...',
    metamaze_being_generated:
      'MetaMaze on työn alla. Saat sähköposti-ilmoituksen, kun se on valmis.',
    metamaze_generate_successfully: 'MetaMaze luotu onnistuneesti!',
    metamaze_with_proceed: 'Voit nyt jatkaa MetaMazella.',
    ai_metamaze_generate: 'AI:n luoma MetaMaze',
    what_kind_maze_create: 'Minkä tyyppisen labyrintin haluat luoda?',
    manual_metamaze_creation: 'Luo MetaMaze manuaalisesti',
    manually_maze_customizing_scnario:
      'Mukauta skenaarioita ja valintoja käsin',
    maze_ai_generated: 'AI:n automaattisesti luoma labyrintti',
    unmark_deadend: 'Poista umpikujan merkintä',
    mark_deadend: 'Merkitse umpikujaksi',
    select_multiple_image_for_scenario:
      'Valitse useita kuvia tätä skenaariota varten.',
    select_your_image: 'Valitsemasi kuva',
    click_to_preview: 'Klikkaa esikatsellaksesi',
    are_you_sure_delete_image: 'Haluatko varmasti poistaa tämän kuvan?',
    select_image_from_library: 'Valitse kuva mediakirjastosta',
    uploading_video: 'Videota ladataan...',
    tree_node_type: 'Puun solmun tyyppi',
    correct_option_scenario: 'Oikea valinta / skenaario',
    incorrect_option: 'Väärä valinta',
    option_scenario_without_text: 'Valinta / skenaario ilman tekstiä',
    dead_end: 'Umpikuja (punainen merkki)',
    correct_path: 'Oikea reitti',
    incorrect_path_not_selected_correct_option_path:
      'Väärä reitti / oikeaa valintaa ei ole valittu',
    double_click_on_tree_node:
      'Kaksoisklikkaa puun solmua nähdäksesi siihen liittyvän skenaarion.',
    add_scenario: 'Lisää skenaario',
    add_option: 'Lisää vaihtoehto',
    an_error_occured: 'Tapahtui virhe:',
    download_summary: 'Lataa yhteenveto',
    step_wise_analysis: 'Vaiheittainen analyysi',
    step: 'Vaihe',
    upload_csv_file: 'Lataa CSV-tiedosto',
    download_template_to_import: 'Lataa malli tuontia varten',
    please_input_email: 'Syötä sähköpostiosoite',
    email_at_least_three_characters:
      'Sähköpostin on sisällettävä vähintään 3 merkkiä',
    email_cannot_be_empty: 'Sähköposti ei voi olla tyhjä',
    input_email_in_new_line: 'Syötä jokainen sähköposti uudelle riville',
    role: 'Rooli',
    select_role: 'Valitse rooli',
    select_group: 'Valitse ryhmä',
    identification_number: 'Tunnistenumero (valinnainen)',
    add_identification_number: 'Lisää tunnistenumero',
    pie_chart_of_all_categories:
      'Piirakkakaavio Sharelookin kaikista kategorioista',
    total_sharesphere_question_answered_by_users:
      'Käyttäjien vastaamat ShareSphere-kysymykset ja onnistumiset/epäonnistumiset',
    voice_style_over_the_text:
      'Käytä eri äänityylejä kirjoitetun tekstin päällä. Lorem Ipsum on ollut alan standarditeksti 1500-luvulta asti.',
    input_your_question: 'Syötä kysymyksesi!',
    make_me_sales_manager: 'Esim. - Tee minusta myyntipäällikkö',
    enter_the_number_relevant_document:
      'Syötä asiaankuuluvien asiakirjojen lukumäärä',
    please_wait_loading_result: 'Odota, tuloksia ladataan...',
    no_result_found: 'Ei tuloksia. Kokeile kysymystä eri tavalla.',
    browser_doesnot_support_iframes: 'Selaimesi ei tue iframeja',
    total_duration: 'Kokonaiskesto',
    number_of_messages: 'Viestien lukumäärä',
    search_result: 'Hakutulos',
    count_result: '(1244 tulosta)',
    your_other_interests: 'Muut kiinnostuksen kohteesi',
    your_total_score: 'Kokonaispisteesi',
    add_a_question: '+ Lisää kysymys',
    travia_question_empty: 'Ei Trivia-kysymyksiä saatavilla',
    video_generation_is_on_queue: 'Videosi luonti on jonossa!',
    checking_video_status: 'Tarkistetaan videon tilaa...',
    total_quizzes: 'Yhteensä visoja',
    number_of_votes: 'Annettujen äänien määrä',
    total_events: 'Yhteensä tapahtumia',
    number_of_rates: 'Arvioiden määrä',
    number_of_likes: 'Tykkäysten määrä',
    all_courses: 'Kaikki kurssit',
    total_questions: 'Yhteensä kysymyksiä',
    no_skill_journey: 'Ei taitomatkoja saatavilla!',
    search_no_results: '- Ei tuloksia!',
    no_image_generated: 'Kuvia ei ole vielä luotu!',
    all_topic_in_this_lesson:
      'Tämä poistaa kaikki aiheet tästä oppitunnista. Toimintoa ei voi perua.',
    content_has_been_generated: 'Sisältö on jo luotu tälle aiheelle.',
    update_course_template: 'Päivitä kurssipohja',
    add_course_template: 'Lisää kurssipohja',
    create_course_now: 'Luo kurssi nyt',
    preview_course: 'Esikatsele kurssia',
    layout: 'Asettelu',
    import_from_youtube: 'Tuo YouTubesta',
    my_media_library: 'Oma mediakirjasto',
    bg_added: 'Taustakuva lisätty',
    add_bg: 'Lisää taustakuva',
    booked_schedule: 'Varauskalenteri',
    add_schedule: 'Lisää aikataulu',
    are_you_delete_schedule: 'Haluatko varmasti poistaa tämän aikataulun?',
    add_task: 'Lisää tehtävä',
    update_calender: 'Päivitä kalenteri',
    manage_cookies: 'Hallitse evästeitä',
    cookie_banner_text:
      'Käytämme evästeitä parantaaksemme selauskokemustasi, analysoidaksemme verkkosivustomme liikennettä ja personoidaksemme sisältöä. Yksityisyytesi on meille tärkeä.',
    accept_all_cookies: 'Hyväksy kaikki evästeet',
    reject_all: 'Hylkää kaikki',
    customize: 'Mukauta',
    cookie_preferences_title: 'Evästeasetukset & tietosuojasäädöt',
    privacy_subtitle:
      'Yksityisyytesi on meille tärkeä. Valitse, mitkä evästeet ovat sinulle sopivia. Voit muuttaa näitä asetuksia milloin tahansa.',
    save_choices: 'Tallenna valintani',
    strictly_necessary: 'Välttämättömät evästeet',
    strictly_necessary_desc:
      'Nämä evästeet ovat välttämättömiä, jotta verkkosivusto toimii asianmukaisesti. Ne mahdollistavat perustoiminnot kuten sivujen navigoinnin, lomakkeiden lähettämisen ja pääsyn suojatuille alueille. Ilman niitä sivusto ei toimi kunnolla.',
    analytics_performance: 'Analytiikka & suorituskyky',
    analytics_performance_desc:
      'Nämä evästeet auttavat meitä ymmärtämään, miten vierailijat käyttävät verkkosivustoamme keräämällä ja raportoimalla tietoja anonyymisti. Tämä auttaa parantamaan sivustomme suorituskykyä ja käyttökokemusta.',
    advertising_marketing: 'Mainonta & markkinointi',
    advertising_marketing_desc:
      'Näitä evästeitä käytetään tekemään mainontaviesteistä sinulle relevantimpia. Ne estävät saman mainoksen toistumasta jatkuvasti ja varmistavat, että mainokset näytetään asianmukaisesti mainostajille.',
    tracking_social: 'Seuranta & sosiaalinen media',
    tracking_social_desc:
      'Nämä evästeet mahdollistavat parannetun toiminnallisuuden ja personoinnin, kuten sosiaalisen median ominaisuudet ja personoidun sisällön. Ne voivat tulla meille tai kolmansilta osapuolilta.',
    functional: 'Toiminnalliset evästeet',
    functional_desc:
      'Nämä evästeet mahdollistavat parannetun toiminnallisuuden kuten chat‑tuki, live‑apu ja muut vuorovaikutteiset ominaisuudet, jotka parantavat selauskokemustasi.',
    your_rights: 'Oikeutesi:',
    rights_description:
      'Voit peruuttaa suostumuksesi milloin tahansa, saada pääsyn tietoihisi tai pyytää niiden poistamista milloin tahansa.',
    withdraw_consent: 'Peruuta kaikki suostumukset',

    how_many_options: 'Montako vaihtoehtoa',
    add_content: 'Lisää sisältöä',
    downloads_center: 'Latauskeskus',
    sharelook_help_center: 'ShareLookin ohjekeskus',
    channel_outline: 'Kanavan rakenne',
    channel_objectives: 'Kanavan tavoitteet',
    no_sop_available: 'Ei saatavilla olevaa SOP‑listaa.',
    generate_world_summary: 'Luo skenaario',
    world_scenario: 'Todellisen maailman skenaario',
    drag_icon_hint: 'Vinkki: Vedä kuvaketta kankaalle asettaaksesi sen',
    drag_text_hint: 'Vinkki: Vedä tekstiä kankaalle asettaaksesi sen',
    edit_badge: 'Muokkaa merkkiä',
    create_new_badge: 'Uusi merkki',
    select_video_preview: 'Valitse video esikatseltavaksi',
    certificate_title_required: 'Todistuksen otsikko vaaditaan',
    discard_changes: 'Hylkää muutokset',
    edit_certificate: 'Muokkaa todistusta',
    add_another_logo: 'Lisää toinen logo',
    optional: 'Valinnainen',
    doc: 'DOC',
    ppt: 'PPT',
    quest_title: 'Luo uusi tehtävä',
    quest_filter_title: 'Tehtävä',
    sharelook_assistance: 'ShareLook‑valmennus',
    upload_scorm_zip: 'Lataa SCORM‑pakkaus',
    only_letters_numbers_space_dot_allowed:
      'Sallitaan vain kirjaimet, numerot, välilyönnit ja pisteet!',
    video_playing: 'Toistetaan',
    course_price_message: `*Koulutus julkaistaan vain organisaation sisäiseen käyttöön eikä sitä voi myydä markkinapaikalla.`,
    lesson_must_be_positive:
      'Lukumäärän oppitunneista on oltava suurempi kuin 1',
    btn_proceed: 'Jatka',
    rule_select_music: 'Valitse musiikki',
    course_info: 'Kurssin tiedot',
    content_selection: 'Sisällön valinta',
    course_content_source: 'Kurssin sisällön lähde',
    choose_how_to_source: 'Valitse, miten hankit sisällön tälle kurssille:',
    automatic_selection: 'Automaattinen valinta',
    system_will_automatically_select_relavant_documents:
      'Järjestelmä valitsee automaattisesti aiheeseen liittyvät asiakirjat kirjastostasi',
    manual_selection: 'Manuaalinen valinta',
    choose_specific_documents_from_your_library:
      'Valitse tiettyjä asiakirjoja kirjastostasi',
    upload_files: 'Lataa tiedostoja',
    upload_new_documents:
      'Lataa uusia asiakirjoja (PDF, DOC, DOCX, PPT, PPTX, TXT) ‑ enintään 5 tiedostoa',
    file: 'tiedosto',
    ready_to_upload: 'valmis lataamaan',
    clear_all: 'Tyhjennä kaikki',
    confirm_course_wide_premiew: 'Vahvista koko kurssin esikatselu',
    generate_course_preview: 'Luo kurssin esikatselu',
    instructions_across_the_course_to_generate:
      'Sovellamme ohjeitasi koko kurssin kattavasti esikatselun luomiseksi. Tarkista kaikki ensin, sitten valitse pidettäväksi tai hylättäväksi.',
    instruction_to_preview_course_wide: 'Ohjeet koko kurssin esikatseluun:',
    edit_content: 'Muokkaa sisältöä',
    manage_course_template: 'Hallitse kurssipohjaa',
    undo: 'Kumoa',
    apply_changes: 'Hyväksy muutokset',
    characters: 'merkkiä',
    apply_all: 'Sovella kaikki',
    apply_to_all: 'Sovella kaikille',
    use_this_content: 'Käytä tätä sisältöä',
    original: 'Alkuperäinen',
    edited: 'Muokattu',
    edited_content_preview: 'Esikatsele muokattua sisältöä',
    apply_edits_to_all_topices: 'Sovella muokkaukset kaikkiin aiheisiin?',
    current_editing_instructions_across_the_whole_course:
      'Tämä soveltaa nykyiset muokkausohjeesi koko kurssille. Voit tarkistaa yhdistetyn esikatselun ennen tallennusta.',
    edit_content_instructions: 'Sisällön muokkausohjeet',
    generate_content_for_this_topic_instruction:
      'Luo sisällön tälle aiheelle ohjeidesi mukaisesti',
    descrip_edit_content:
      'Kuvaa, miten tätä sisältöä muokataan (esim. lyhennä, yksinkertaista, muotoile uudelleen)',
    try_short_clear_direcctives: `Kokeile lyhyitä, selkeitä ohjeita. Esimerkit: “rajaa 100 sanaan, säilytä pääkohdat”, “yksinkertaista kieli”, “tee tiiviimmäksi ja poista rönsyjä”.`,
    we_preserve_the_core_meaning: 'Säilytämme ydinsisällön muokatessamme sitä.',
    feedback_optional: 'Palaute (valinnainen)',
    write_your_feedback_here: 'Kirjoita palautteesi tähän',
    from_web: 'Verkosta',
    from_desktop: 'Työpöydältä',
    pleae_wait_processing: 'Odota, käsittelemme...',
    create_simulation_from_screen_capture: 'Luo simulointi näyttökaappauksesta',
    sharelook_not_found: 'ShareLookia ei löytynyt',
    sharelook_screen_capture_application_not_be_opened:
      'ShareLook‑näyttökaappausohjelmaa ei voitu avata. Se ei ehkä ole asennettu koneellesi.',
    download_sharelook: 'Lataa ShareLook',
    launch_sharelook_application: 'Käynnistä ShareLook‑sovellus',
    this_will_open_the_sharelook_application_for_screen_capture:
      'Tämä avaa ShareLook‑sovelluksen näyttökaappauksia varten.',
    sharelook_dosenot_open:
      'Jos ShareLook ei avaudu, se ei ehkä ole asennettu tietokoneellesi.',
    open_sharelook: 'Avaa ShareLook',
    download_app: 'Lataa sovellus',
    background_image_setting: 'Taustakuvan asetukset',
    current_image: 'Nykyinen kuva',
    change_image: 'Vaihda kuva',
    remove_image: 'Poista kuva',
    no_background_image_selected: 'Ei valittua taustakuvaa',
    add_image: 'Lisää kuva',
    this_will_open_for_screen_recording:
      'Tämä avaa sovelluksen näytön tallennusta varten.',
    ai_image_generation: 'AI‑kuvageneraattori',
    image_edit: 'Kuvan muokkaus',
    text_to_image: 'Teksti kuvaksi',
    output_gallary: 'Tulostegalleria',
    instant_generation: 'Valmis välittömään generointiin',
    prompt_and_unleash_the_power: 'Anna kehotteesi ja vapauta voima',
    use_this_image: 'Käytä tätä kuvaa',
    error_generating: 'Virhe generoinnissa.',
    generation_tips: 'Generointivinkkejä',
    detailed_descriptions_for_more_accurate_results:
      'Käytä yksityiskohtaisia kuvauksia tarkempien tulosten saamiseksi',
    reference_image: 'Viitekuva',
    select_pixel_image: 'Valitse pikselikuva',
    max_mb: 'Maksimi 50 Mt',
    please_enter_text_to_appear_image: 'Anna teksti, joka näkyy kuvassa',
    enter_text_to_apear_in_the_image: 'Anna tekstisi, joka näkyy kuvassa',
    generate_image: 'Luo kuva',
    prompt_assistant: 'Kehoteavustaja',
    generate_image_using_suggested_prompt:
      'Luo kuva käyttäen ehdotettua kehotea',
    talk_to_ai_about_the_image_generate:
      'Keskustele tekoälyn kanssa haluamastasi kuvasta',
    ask_for_prompt_suggestions: 'Pyydä kehote‑ehdotuksia…',
    enter_a_search_term_to_find_stock_images:
      'Anna hakusana löytääksesi arkistokuvia',
    choose_your_content_source: 'Valitse sisältölähteesi:',
    upload_new_document_from_your_device: 'Lataa uusi asiakirja laitteeltasi',
    automatic_library_selection: 'Automaattinen kirjaston valinta',
    system_automatically_selects_relevant_document:
      'Järjestelmä valitsee automaattisesti aiheeseen liittyvän asiakirjan',
    manual_library_selection: 'Manuaalinen kirjaston valinta',
    generate_content: 'Luo sisältöä',
    add_to_current_page: 'Lisää nykyiselle sivulle',
    generate_bullet_points: 'Luo luettelopisteitä',
    generating: 'Luodaan',
    this_may_take_a_few_moments: 'Tämä voi viedä hetken',
    apply_to_page: 'Sovella sivulle',
    scenario_escription: 'Skenaariokuvaus:',
    feedback: 'Palaute',
    form_mode: 'Lomaketila',
    chat_mode: 'Chat‑tila',
    this_will_generate_a_continuation_of_the_seleccted_story:
      'Tämä luo valitun tarinan jatkon tekoälyn avulla.',
    continue_this_story_question: 'Jatketaanko tätä tarinaa?',
    continue_this_story: 'Jatka tätä tarinaa',
    what_will_happen: 'Mitä tapahtuu:',
    the_ai_will_analyze_the_existing_story_content:
      'Tekoäly analysoi nykyisen tarinasisällön.',
    generate_a_natural_continuation_that_follows_the_same_tone:
      'Luo luonteva jatko, joka noudattaa samaa sävyä ja tyyliä.',
    create_new_content_that_build_upon_the_current_narrative:
      'Luo uutta sisältöä, joka rakentuu nykyisen narratiivin pohjalta.',
    this_process_may_take_a_few_moments_to_complete:
      'Tämä prosessi saattaa kestää hetken.',
    no_existing_stories_found_for_this_course:
      'Tälle kurssille ei löytynyt olemassa olevia tarinoita.',
    create_your_first_story: 'Luo ensimmäinen tarinasi',
    existing_stories: 'Olemassa olevat tarinat',
    create_new_story: 'Luo uusi tarina',
    tone: 'Sävy',
    style: 'Tyyli',
    genre: 'Genre',
    loading_your_stories: 'Ladataan tarinoitasi…',
    edit_story: 'Muokkaa tarinaa',
    story_preferences: 'Tarinan asetukset',
    please_input_your: 'Anna',
    add_character_names_and_press_enter: 'Lisää hahmonimet ja paina Enter',
    select_or_type_your: 'Valitse tai kirjoita',
    enter_your: 'Anna sinun',
    position_of_the_story_in_the_lesson:
      'Tarinan sijainti oppitunnissa. Tarina lisätään lohkona määritettyyn kohtaan.',
    save_previous_content_on_the_pages: 'Tallenna edellinen sisältö sivuilla',
    the_existing_content_in_the_selected_pages:
      'Valittujen sivujen nykyinen sisältö korvataan luodulla tarinalla.',
    real_world_scenario: 'Todellisen maailman skenaario',
    add_optional_instructions:
      'Lisää valinnaiset ohjeet (sävy, pituus, kohdeyleisö jne.)',
    ready_to_enerate_your_real_world_scenario:
      'Valmis luomaan todellisen maailman skenaario',
    click_generate_real_world_scenario_to_create_a_realistic_scenario:
      'Klikkaa “Luo todellisen maailman skenaario” luodaksesi realistisen skenaarion oppisisällön perusteella.',
    the_ai_will_analyze_your_lesson_topic_and_content:
      'Tekoäly analysoi oppiaineen aiheen ja sisällön.',
    generate_a_practical_real_world_scenario:
      'Luo käytännöllinen todellisen maailman skenaario',
    you_can_then_edit_and_customize_the_result:
      'Voit sitten muokata ja räätälöidä tuloksen.'
  },
  v3: {
    reportShareSphere: 'SHARESPHERE',
    overview: 'Yleiskatsaus',
    triviaReport: 'ShareSphere Trivia',
    overviewGraph: 'Yleiskatsauskaavio',
    category: 'Kategoria',
    phCategory: 'Valitse kategoria',
    podcast: 'Podcastit, musiikki ja tarinat',
    pastPodcast: 'Aiemmat podcastit',
    upcomingPodcast: 'Tulevat podcastit',
    podcastLanguageTitle: 'Podcastit, musiikki ja tarinat -kielten valinta',
    podcastLanguageCheckbox: 'Luo AI-kieliversio podcastilleni',
    howRate: 'Miten arvioisit tämän podcastin?',
    podcastSubmit: 'Lähetä',
    podcastGuest: 'Vierasjuontaja:',
    podcastReview: 'Arvostelut',
    podcastEpishode: 'Jaksoja',
    podcastEnd: 'Podcast päättynyt',
    date_podcast: 'Podcastin päivämäärä',
    skill_not_found: 'Valitettavasti! Taitopolku ei löytynyt.',
    coaching: 'Valmennus',
    webinar: 'Webinaari',
    public_conference: 'Julkinen konferenssi',
    skill_journey_subtitle:
      'Lisää asetuksia taitopolullesi ja valitse, ketkä voivat nähdä ja olla vuorovaikutuksessa sen kanssa.',
    enable_white_label: 'Ota valkoinen merkki käyttöön',
    create_new_event_org: 'Luo uusi tapahtuma organisaatiollesi',
    create_new_event_marketplace: 'Luo uusi tapahtuma markkinapaikalle',
    create_new_event_both:
      'Luo uusi tapahtuma sekä organisaatiollesi että markkinapaikalle',
    event_outline: 'Lisää tapahtuman yleiskuvaus',
    event_obj: 'Lisää tapahtuman tavoitteet',
    event_description: 'Lisää tapahtuman kuvaus',
    create_new_metamaze_org: 'Luo uusi MetaMaze organisaatiollesi',
    create_new_metamaze_marketplace: 'Luo uusi MetaMaze markkinapaikalle',
    create_new_metamaze_both:
      'Luo uusi MetaMaze sekä organisaatiollesi että markkinapaikalle',
    add_key_words: 'Lisää avainsanoja',
    press_enter_make_keyword: 'Paina Enter luodaksesi avainsanan',
    disable_skip_quiz: 'Poista mahdollisuus ohittaa kysely',
    warning_complete_quiz: 'Ole hyvä ja suorita kysely loppuun jatkaaksesi.',
    signup_email_verification:
      'Vahvistuslinkki on lähetetty antamaasi sähköpostiosoitteeseen. Siirry linkkiin vahvistaaksesi rekisteröitymisesi.',
    verifying_registration: 'Vahvistetaan rekisteröitymistä...',
    reset_password_linK:
      'Linkki on lähetetty antamaasi sähköpostiosoitteeseen. Siirry linkkiin asettaaksesi uuden salasanan.',
    reset_email_error:
      'Tätä sähköpostia ei löydy, yritä uudelleen käyttäjänimellä.',
    first_name: 'Etunimi',
    last_name: 'Sukunimi',
    error_firstName: 'Ole hyvä ja syötä etunimesi',
    error_sharebot_organization: 'Ole hyvä ja syötä organisaatiosi nimi',
    error_lastName: 'Ole hyvä ja syötä sukunimesi',
    private_conference: 'Yksityinen konferenssi',
    public_conference: 'Julkinen konferenssi',
    discussion_room: 'Keskusteluhuone',
    training_no_courses: 'Sinulla ei ole tällä hetkellä kursseja.',
    training_no_events: 'Sinulla ei ole tällä hetkellä tapahtumia.',
    allow_sharing_trainer_info: 'Salli sähköpostin jakaminen markkinapaikalla',
    error_username_space: 'Käyttäjänimessä ei voi olla välilyöntejä.',
    error_sharebot_organization_space:
      'Organisaation nimessä ei voi olla välilyöntejä.',
    edit_permission: 'Muokkausoikeus',
    valid_price: 'Hinnan tulee olla suurempi kuin 0',
    course_price_message: `*Kurssi julkaistaan vain organisaation ostamien käyttäjien määrälle eikä sitä voi myydä uudelleen markkinapaikalla.`,
    valid_edit_price: 'Muokattavan hinnan tulee olla pienempi kuin ostohinta.',
    my_calendar: 'Oma kalenteri',
    error_valid_firstName: 'Ole hyvä ja syötä kelvollinen etunimi.',
    error_valid_organization:
      'Ole hyvä ja syötä kelvollinen organisaation nimi.',
    error_valid_lastName: 'Ole hyvä ja syötä kelvollinen sukunimi.',
    error_name_spaces: 'Nimessä ei voi olla välilyöntejä.',
    items: 'Tuotteet',
    publish_to_channel: 'Julkaise omaan kanavaani',
    create_a_channel: 'Luo oma kanava',
    create_a_trivia: 'Luo tietovisa',
    create_a_new_channel: 'Luo uusi kanava',
    add_videos: 'Lisää videoita',
    save_and_continue: 'Tallenna ja jatka',
    channel: 'Kanava',
    channels: 'Kanavat',
    view_channel: 'Katso kanavaa',
    edit_channel: 'Muokkaa kanavaa',
    delete_channel: 'Poista kanava',
    my_video_channels: 'Omat videokanavat',
    training_no_channel: 'Sinulla ei ole tällä hetkellä kanavia.',
    monthly_price_required: 'Kuukausihinta vaaditaan',
    yearly_price_required: 'Vuosihinta vaaditaan',
    one_time_price_required: 'Kertamaksuhinta vaaditaan',
    marketplace_quantity: 'USD',
    report_webinar: 'Webinaari',
    report_coaching: 'Valmennus',
    report_channel: 'Kanava',
    report_public_conference: 'Julkinen konferenssi',
    report_maze: 'Labyrintti',
    channel: 'Kanava',
    edit_price: 'Muokkaa hintaa ($)',
    quantity: 'Määrä',
    payment_type: 'Maksutyyppi',
    total_amount: 'Kokonaissumma ($)',
    net_amount: 'Nettomäärä ($)',
    edit_option: 'Muokkausvaihtoehto',
    marketplace_price: 'Hinta ($)',
    market_name: 'Nimi',
    duration_min: 'Kesto (min)',
    users_total: 'Käyttäjät yhteensä',
    sales_total: 'Myynti yhteensä (USD)',
    search_coaching: 'Valmennuksen haku',
    search_channel: 'Kanavan haku',
    search_webinar: 'Webinaarin haku',
    search_maze: 'Labyrintin haku',
    search_public_conference: 'Julkisen konferenssin haku',
    buyer_type: 'Ostajan tyyppi',
    quanity: 'Määrä',
    channel_unit_amount: 'Nettomäärä ($)',
    channel_updated_at: 'Viimeksi päivitetty',
    month: 'Kuukausi',
    year: 'Vuosi',
    onetime: 'Kertamaksu',
    marketplace: 'Markkinapaikka',
    marketplace_price_per_month: 'Kuukausihinta',
    marketplace_price_per_year: 'Vuosihinta',
    marketplace_price_onetime: 'Kertamaksuhinta',
    month_label: 'Kuukausi',
    year_label: 'Vuosi',
    one_time_label: 'Kertamaksu',
    select_filter: 'Valitse suodatin',
    search_filter_placeholder: 'Kirjoita haettava sana',
    no_result_found: 'Tulosta ei löytynyt',
    ai_course_title: 'Kurssin otsikko',
    ai_input_course_title: 'Ole hyvä ja syötä kurssin otsikko!',
    learning_objective_label: 'Oppimistavoite',
    learning_objective_message: 'Ole hyvä ja syötä oppimistavoite!',
    standard_question:
      'Onko olemassa standardia, jota oppijan tulee noudattaa?',
    standard_details_label: 'Standardin tiedot',
    standard_details_message: 'Ole hyvä ja syötä standardin tiedot!',
    estimated_duration_label: 'Arvioitu kurssin kesto (minuuteissa)',
    estimated_duration_message: 'Ole hyvä ja syötä arvioitu kesto!',
    min_duration_message: 'Minimikesto on 5 minuuttia.',
    ai_mins: '25 min',
    industry_specific_question: 'Onko se teollisuuskohtainen?',
    industry_label: 'Määrittele teollisuus',
    industry_message: 'Ole hyvä ja syötä teollisuus!',
    ai_course_creation: 'AI-kurssin luonti',
    course_generated: 'Kurssi luotu Sharelookin avulla',
    ai: 'AI',
    ai_you: 'Sinä',
    ai_prompt_ready: 'Kehote on valmis. Voit nyt luoda sisällysluettelon.',
    ai_unable_respond:
      'Pahoittelut! AI ei pysty vastaamaan kehotteeseesi. Yritä uudelleen.',
    ai_hide_toc: 'Piilota sisällysluettelo',
    ai_preview_toc: 'Esikatsele sisällysluettelo',
    ai_generate_toc_now: 'Luo sisällysluettelo nyt',
    ai_creation_course_title: 'Kurssin otsikko:',
    ai_creation_industry_specific: 'Onko se teollisuuskohtainen:',
    ai_creation_industry: 'Teollisuus:',
    ai_creation_standard_needed:
      'Onko oppijan noudatettava jotain standardia?:',
    ai_creation_standard_details: 'Standardin tiedot:',
    ai_creation_estimated_duration: 'Arvioitu kurssin kesto (minuuteissa):',
    minutes: 'minuuttia',
    ai_creation_learning_objective: 'Oppimistavoite:',
    setup_again: 'Määritä uudelleen',
    ai_creation_confirm_title:
      'Haluatko varmasti määrittää lomakkeen uudelleen?',
    ai_creation_confirm_content:
      'Keskustelu ja kaikki luomasi sisältö nollataan.',
    ai_toc: 'Sisällysluettelo',
    ai_note_topic:
      'Huomaa: Voit vetää ja pudottaa aiheita uudelleen järjestääksesi ne oppitunnin sisällä.',
    ai_add_topic: '+ Lisää aihe',
    add_topic: 'Lisää aihe',
    add_lesson: 'Lisää oppitunti',
    add_new_lesson: 'Lisää uusi oppitunti',
    ai_add_lesson: '+ Lisää oppitunti',
    attention: 'Huomio',
    before_varifying: 'Ennen vahvistamista',
    ai_save_later: 'Tallenna myöhemmin',
    ai_download_word_doc: 'Lataa Word-dokumenttina',
    ai_download_course_word_doc: 'Lataa kurssi Word-dokumenttina',
    ai_create_course_button: 'Luo kurssi',
    ai_generate_course_content: 'Luo kurssis sisältö',
    ai_out_of: ' / ',
    ai_subtopic_failed_content:
      'ala-aiheiden sisällön luonti epäonnistui. Klikkaa "Luo kurssis sisältö" uudelleen luodaksesi sisällön vain näille ala-aiheille.',
    ai_edit_topic: 'Muokkaa aihetta',
    ai_edit_lesson_title: 'Muokkaa oppitunnin otsikkoa',
    ai_save_topic: 'Tallenna aihe',
    ai_save: 'Tallenna',
    ai_save_lesson_title: 'Tallenna oppitunnin otsikko',
    ai_add_new_topic: 'Lisää uusi aihe',
    ai_download_ref: 'Lataa viitteiden kanssa',
    ai_download_ref_content:
      'Lataa kurssi Word-dokumenttina viitteiden kanssa.',
    ai_download_without_ref: 'Lataa ilman viitteitä',
    ai_download_two_word: 'Kaksi Word-dokumenttia ladataan:',
    ai_download_two_word_content_one:
      '- yksi sisältäen pääsisällön ilman viitteitä,',
    ai_download_two_word_content_two:
      'ja toinen pelkästään viitelistauksen ilman sisältöä.',
    ai_manage_content: 'Hallitse sisältöä',
    ai_add_content_from_internet: '+ Lisää sisältöä internetistä',
    ai_confirm_start: 'Vahvista aloitus',
    ai_Verify: 'Vahvista',
    ai_undo_warning:
      'Tämä prosessi voi kestää hetken. Älä sulje tätä ikkunaa, ennen kuin luonti on valmis, sillä sitä ei voi peruuttaa.',
    ai_verified_content:
      'Olet vahvistanut sisällön. Huomaa, että vahvistuksen jälkeen et voi palata keskustelemaan AI-avustajan kanssa nykyisestä sisällöstä.',
    ai_want_proceed: 'Haluatko varmasti jatkaa?',
    upload_simulation: 'Lataa simulaatio',
    name_simulation: 'Simulaation nimi',
    selected_simulation_files: 'Valitut simulaatiotiedostot',
    score_between_one_hundred: 'Pisteesi tulee olla välillä 1 - 100.',
    are_sure_simulation: 'Haluatko varmasti poistaa tämän simulaatiotiedoston?',
    required_simulation: 'Piste on pakollinen',
    required_section_file: 'Osatiedosto on pakollinen',
    simulation: 'Simulaatio',
    simulation_quiz_games: 'Tarvitsetko lisätä visan peleihin',
    simulation_alert_des:
      'Voit lisätä pelejä vain, jos kaikilla kysymyksillä on joko yksittäinen tai monivalintavastaus.',
    alert_info: 'tieto',
    ai_number_quiz: 'Visojen määrä',
    ai_point: 'Piste',
    ai_points: 'Pisteet',
    val_required: 'Pakollinen',
    games: 'Pelit',
    add_simulation: 'Lisää simulaatio',
    text_tiewer: 'Tekstin katseluohjelma',
    back_to_account: 'Takaisin tilille',
    delete_account: 'Poista tili',
    delete_account_title: 'Poista tili ???',
    delete_account_subtitle: 'Voit poistaa tilisi täältä.',
    delete_account_cannot_undo:
      'Olet poistamassa tiliäsi. Tätä toimintoa ei voi kumota.',
    account_org_profile:
      'Menetät myös kaikki luomasi kurssit, organisaatioprofiilisi ja kaikki asetuksesi.',
    deleting_account_database:
      'Tilin poistaminen poistaa kaikki tietosi tietokannastamme.',
    account_confirm_delete: 'Haluatko varmasti poistaa tilisi?',
    action_cannot_be_undone: 'Tätä toimintoa ei voi peruuttaa.',
    account_delete_message_success: 'Tilisi on poistettu onnistuneesti.',
    message_edit: 'Muokkaa',
    message_delete: 'Poista',
    message_reply: 'Vastaa',
    attached_file: 'Liitetty tiedosto',
    attach_file: 'Liitä tiedosto',
    attach_des: '25 Mt, suurin tiedostokoko',
    view: 'Näytä',
    go_to_marketplace: 'Siirry markkinapaikalle',
    learning_center: 'Oppimiskeskus',
    knowledge_center: 'Tietokeskus',
    sharebot: 'ShareBot',
    sharebot_help_message: 'Miten voin auttaa sinua tänään?',
    my_organization: 'Organisaationi',
    world_knowledge: 'Maailman tieto',
    welcome_to_sharelook: 'Tervetuloa Sharelookiin!',
    sharelook_you_want_go: 'Minne haluat mennä tänään?',
    shareLook_learning_management_system:
      'Käytä ShareLookin oppimisen hallintajärjestelmää luodaksesi tai käyttääksesi oppimateriaaleja kuten live-tapahtumia ja kursseja organisaatiossasi.',
    shareLook_powerful_ai_system:
      'Käytä ShareLookin tehokasta tekoälyjärjestelmää, jossa voit ladata PDF-tiedostoja ja saada hyödyllisiä oivalluksia sekunneissa. Hae nopeita vastauksia organisaatiosi materiaaleista tai käytä yleistä tekoälyjärjestelmää Maailman tieto -osiossa.',
    edit_now: 'Muokkaa nyt',
    sharelook_log_out:
      'Olet kirjautunut ulos Sharelookista. Ole hyvä ja kirjaudu sisään!',
    sorry_error: 'Valitettavasti! Koimme virheen.',
    login: 'Kirjaudu sisään',
    refresh_page: 'Päivitä sivu',
    just_a_moment: 'Hetkinen',
    enter_lname_fname: 'Ole hyvä ja syötä etu- ja sukunimesi jatkaaksesi.',
    procced_to_sharelook: 'Jatka Sharelookiin',
    option_one: 'Vaihtoehto 1',
    option_two: 'Vaihtoehto 2',
    selected_image: 'Valittu kuva:',
    add_text: 'Lisää teksti',
    linkdin_is_required: 'LinkedIn on pakollinen.',
    bio_is_required: 'Bio on pakollinen.',
    save_user_information: 'Tallenna käyttäjätiedot',
    select_all: 'Valitse kaikki',
    enable_ai: 'Ota AI käyttöön',
    load_more: 'Lataa lisää',
    channel_id: 'Kanavan ID.',
    send: 'Lähetä',
    v4: 'Tieto',
    subscription: 'Tilaus',
    reset_user_flag: 'Nollaa käyttäjälippu',
    delete_my_accont: 'Poista tilini',
    sharebot_sub_error: 'Virhe tilausten haussa. Yritä uudelleen!',
    sharebot_no_sub: 'Sinulla ei ole aktiivisia tilauksia.',
    sharebot_dont_sub: 'Sinulla ei ole aiempia tilauksia.',
    sharebot_prev_sub: 'Aiemmin tilattu',
    sharebot_sub: 'ShareBot-tilaus',
    sharebot_un_sub: 'ShareBot-tilauksen peruuttaminen',
    sharebot_no_available: 'Kuvausta ei ole saatavilla',
    sharebot_start_date: 'Alkamispäivä:',
    sharebot_end_date: 'Päättymispäivä:',
    sharebot_sure: 'Oletko varma?',
    sharebot_do_you_want: 'Haluatko',
    unsubscribe: 'peruuttaa tilauksen',
    unsubscribe_what: 'peruuttaa tilauksen?',
    subscribe: 'tilaa',
    subscribe_what: 'tilaa?',
    subscribe_now: 'Tilaa nyt',
    confirm: 'Vahvista',
    sharebot_intel_knowledge_center: 'ShareBotin älykäs tietokeskus',
    sharebot_welcome_paragraph:
      'Tervetuloa ShareBotin tietokeskukseen, edistykselliseen AI-chatbotiin, joka muuttaa ammattilaisten tiedonhaku- ja yhteistyötavat.',
    expired: 'Vanhentunut',
    active: 'Aktiivinen',
    Inactive: 'Ei aktiivinen',
    yearly_subscription: 'Vuositilaus',
    monthly_subscription: 'Kuukausitilaus',
    no_sharebot_org: 'Sinulla ei ole ShareBot-organisaatiota',
    sharebot_start_free_trial: 'Aloita ilmainen kokeilu',
    sub_month: 'Kuukausitilaus',
    sub_year: 'Vuosittainen tilaus',
    question_per_month: 'Tietovarasto (1TB) ja 1000 kysymystä pysyvästi',
    sharebot_para:
      'Jatkamalla vahvistat, että haluat poistaa organisaation pysyvästi. Tämä toiminto poistaa kaikki ShareBotin tarjoamat arvokkaat resurssit eikä sitä voi kumota.',
    cancelled_date: 'Peruutuspäivämäärä:',
    live_straming_para:
      'Jos haluat muuttaa kuukausittaisen live-striimausrajan, ota yhteyttä',
    sharelook_agree: 'Hyväksyn Sharelookin',
    terms_condition: 'käyttöehdot',
    and: 'ja',
    privacy_policy: 'tietosuojakäytäntö',
    save_for_later: 'Tallenna myöhempää käyttöä varten',
    ai: 'AI',
    no_video_yet: 'Ei videota valittuna!',
    are_you_sure_delete_video: 'Haluatko varmasti poistaa tämän videon?',
    video_des: 'Kuvaus',
    video_now: 'Nyt',
    video_playing: 'Toistetaan:',
    video_no: 'Video nro',
    ai_generated_course: 'AI:lla luotu kurssi',
    create_course_on_our_own: 'Luo kurssi itse',
    ai_Assisted_ourse_reation: 'AI-avusteinen kurssin luonti',
    pending: 'Odottaa',
    published: 'Julkaistu',
    intro_course: 'Lisätäänkö kurssiin?',
    clone_course: 'Haluatko kloonata kurssin?',
    browser_audio_not_support: 'Selaimesi ei tue äänielementtiä.',
    audio_popup_content:
      'Voit lisätä useita ääniä kirjoittamasi tekstin mukaan — Lorem Ipsum on vakioteksti, jota on käytetty vuodesta 1500.',
    close: 'Sulje',
    podcast_rec: 'TALLENNUS',
    create_podcast: 'Luo podcast',
    add_admin: 'Lisää ylläpitäjä',
    delete_all: 'Poista kaikki',
    ai_podcast_audio: 'AI Podcast -ääni',
    language: 'Kieli',
    podcast_download_content:
      '*Voit ladata AI-käännöksen äänenä ja muokata sitä omassa editorissasi.',
    upload_audio: 'Lataa ääni',
    browser_do_not_support_audio: 'Selaimesi ei tue äänielementtiä.',
    upload_cover: 'Lataa kansikuva',
    upload_ai_creator: 'Lisää AI-luoja',
    required_cover_image: 'Kansikuva on pakollinen!',
    room_required_name: 'Podcastin nimi on pakollinen!',
    add_guest_list: 'Lisää vieraita!',
    podcast_add_participants: 'Lisää osallistujia',
    topic_required: 'Vaaditaan vähintään yksi aihe',
    podcast_description: 'Kuvaus',
    podcast_date: 'Päivämäärä',
    date: 'Päivämäärä',
    podcast_time: 'Aika',
    podcast_to: '–',
    podcast_all_day: 'Koko päivä',
    podcast_start_date_time: 'Alkupäivämäärä ja aika vaaditaan!',
    podcast_id: 'ID',
    selected_user: 'Kutsutaan valitut käyttäjät',
    see_more: 'Näytä lisää',
    see_less: 'Näytä vähemmän',
    no_review_yet: 'Ei arvosteluja vielä – ole ensimmäinen!',
    request_to_speak: 'Hyväksytäänkö käyttäjän puhepyyntö?',
    kick_user: 'Haluatko poistaa tämän käyttäjän?',
    accept_request: 'Hyväksy pyyntö',
    kick: 'Poista',
    started: 'Alkanut',
    end: 'Päättynyt',
    join_now: 'Liity nyt',
    podcast_end: 'Podcast on päättynyt',
    connecting: 'Yhdistetään...',
    knowledge_center_know_today: 'Mitä haluat tietää tänään?',
    knowledge_center_question: 'Kirjoita kysymyksesi',
    knowledge_center_error: 'Pahoittelut! Tapahtui virhe.',
    knowledge_center_tooltrip:
      'Pääset käsiksi tiimisi oppimissisältöön ja lataat PDF-tiedostoja.',
    my_organization: 'Oma organisaatio',
    world_knowledge: 'Maailman tieto',
    open_file: 'Avaa tiedosto',
    reference: 'Viite',
    are_you_cancel: 'Haluatko varmasti peruuttaa?',
    are_you_remove_media: 'Haluatko varmasti poistaa median?',
    terms_agree: 'Hyväksyn ehdot',
    ready: 'Valmis',
    send_email: 'Lähetä sähköposti',
    active_users: 'Aktiiviset käyttäjät',
    sign_up_user: 'Rekisteröityneet käyttäjät',
    non_sign_up_user: 'Ei-rekisteröityneet käyttäjät',
    organisation: 'Organisaatio',
    usage_report: 'Käyttöraportti',
    check_email: 'Tarkista sähköposti',
    delete_schedule: 'Poista aikataulu',
    are_you_sure_delete_schedule: 'Haluatko varmasti poistaa tämän aikataulun?',
    add_task: 'Lisää tehtävä',
    coaching_available: 'Valmis coachingiin',
    message_booking_coaching: 'Tämä aika on jo varattu coachingia varten.',
    task_day: 'Tehtäväpäivä',
    created_task_day: 'Olet jo luonut tehtävän tänään.',
    event_day: 'Tapahtumapäivä',
    has_booked_coaching: 'Coaching on jo varattu tälle päivälle.',
    active_day: 'Aktiivinen päivä',
    selectable_time_slots:
      'Valittavat ajankohdat ovat käytettävissä oikean päivän kohdalla.',
    compare_last_month: 'Vertaa viime kuuhun',
    uploading_file: 'Tiedostoa ladataan',
    attach_file_course: 'Liitetty kurssiin',
    fetch_request: 'Noudetaan pyyntöäsi',
    finilize_upload: 'Viimeistellään latausta',
    scorm_scanned: 'Odota... SCORM-zip tarkistetaan.',
    scan_status: 'Skannauksen tila:',
    scan_completed: 'Tarkistus valmis. Tiedosto on',
    scan_progress: 'Skannaus meneillään...',
    check_scorm: 'Tarkistetaan SCORM-tiedosto...',
    file_check_success: 'Tarkistus onnistui',
    file_check_progress: 'Tiedoston tarkistus meneillään',
    scorm_not_upload:
      'Lähettämäsi tiedosto ei ole SCORM 1.2 -yhteensopiva. Lähetä uusi.',
    select_question: 'Valintakysymys (vain yksi oikein)',
    select_answer: 'Valitse vastaus!',
    check_option_one: 'Kirjoita vaihtoehto!',
    check_option_two: 'Kirjoita kaksi vaihtoehtoa!',
    check_option_three: 'Kirjoita kolme vaihtoehtoa!',
    check_option_four: 'Kirjoita neljä vaihtoehtoa!',
    question_image: 'Kysymyskuva',
    select_question_image: 'Valitse kysymyskuva!',
    ans_image: 'Vastauskuva',
    upload_image_question: 'Lataa kysymyskuva',
    select_image_answer: 'Valitse vastauskuva!',
    save_question: 'Tallenna kysymys',
    do_you_leave: 'Haluatko poistua? Oletko varma?',
    loose_all_progress: 'Kaikki edistyminen menetetään.',
    welcome: 'Tervetuloa',
    team_knowledge_quest: 'Tiimin tietoseikkailu',
    your_score: 'Pisteesi',
    start_playing: 'Aloita pelaaminen',
    share_sphere_complete: 'ShareSphere suoritettu',
    final_score: 'Loppupisteet',
    play_next: 'Pelaa seuraava',
    you_donot_access_event: 'Sinulla ei ole pääsyä tähän tapahtumaan',
    ai_content_generated: 'AI-sisältö luotu tälle aiheelle',
    ai_popup_confirm_content: 'Vahvista luotava sisältö',
    limit_transcribe_text:
      'Jäljellä olevat tekstitysminuutit: <0>{{ transcribe_limit }}</0> minuuttia <1/><2/> <3>. Muuttaaksesi tekstityksen rajoitusta, ota yhteyttä </3> <4>admin@sharelook.com</4>.',
    you_donot_access_event: 'Sinulla ei ole pääsyä tähän tapahtumaan.',
    ai_course_title_training: 'Johtajuuskoulutukset',
    ai_course_object: 'Johtajuuden navigointi digitaaliaikana',
    create_ai_video: 'Luo AI-video',
    generate: 'LUO',
    video_generate_process:
      'Videon luontiprosessi saattaa viedä aikaa. Saat sähköpostia, kun se on valmis.',
    stripe_account_connect:
      'Stripe-tilisi on ei-aktiivinen. Jatkaaksesi yhdistä tai aktivoi se.',
    ai_creator: 'AI-luoja',
    check_video_status: 'Tarkistetaan videon luontitilaa...',
    video_on_queue: 'Videon luonti on jonossa.',
    video_fail_generation:
      'Valitettavasti videon luonti epäonnistui. Yritä uudelleen.',
    video_currently_generated: 'Tätä videota luodaan parhaillaan.',
    checking_status: 'Tarkistetaan tilaa',
    check_status: 'Tarkista tila',
    browser_does_not_support_audio: 'Selaimesi ei tue ääni-tunnistetta',
    existing_edit_scenario:
      'Haluatko muokata olemassa olevaa skenaariota vai luoda uuden? Uuden luominen poistaa vanhan skenaarion.',
    generate_scenario: 'Luo skenaario',
    layout: 'Asettelu',
    confirm_change: 'Vahvista muutos',
    generated_ai_creation_message:
      'Huomioithan, että vain AI-luodut tekstielementit säilyvät. Kaikki muut elementit poistetaan sivulta.',
    generate_story: 'Luo tarina',
    save_original_content: 'Tallenna alkuperäinen sisältö:',
    story_added_specified_position:
      'Tarina sijoitetaan oppitunnin määriteltyyn kohtaan lohkona.',
    position_of_story: 'Tarina sijoitus',
    start_the_lesson: 'Oppitunnin alku',
    end_the_lesson: 'Oppitunnin loppu',
    add_story_pages: 'Lisää tarina sivuille',
    browser_does_not_support: 'Selaimesi ei tue ääni-elementtiä.',
    no_video_available: 'Videoita ei ole saatavilla.',
    no_podcast_available: 'Podcasteja ei ole saatavilla.',
    no_item_baskets: 'Ostoskori on tyhjä.',
    ai_course_object: 'Johtajuuden navigointi digitaaliaikana'
  },
  v2: {
    n_data: 'Ei tietoja',
    change: 'Vaihda',
    remove: 'Poista',
    auto_background: 'Automaattinen tausta',
    create_new_course_org: 'Luo uusi kurssi organisaatiollesi.',
    create_new_course_marketplace: 'Luo uusi kurssi markkinapaikalle.',
    create_new_course_both:
      'Luo uusi kurssi sekä organisaatiollesi että markkinapaikalle.',
    ok: 'Ok',
    page_bg: 'Sivun tausta',
    lesson_cover: 'Oppitunnin kansikuva',
    create_skill_journey: 'Luo taitomatka',
    Metamaze: 'Metamaze',
    events: 'Tapahtumat',
    scroms: 'SCORMit',
    min_score_pass: 'Vähimmäispistemäärä hyväksymiseen',
    no_scorms_available: 'SCORMeja ei ole saatavilla.',
    no_events_available: 'Tapahtumia ei ole saatavilla.',
    no_courses_available: 'Kursseja ei ole saatavilla.',
    no_courses_baskets: 'Ostoskorissa ei ole kursseja.',
    no_mazes_baskets: 'Ostoskorissa ei ole sokkeloita.',
    no_scroms_baskets: 'Ostoskorissa ei ole SCORMeja.',
    no_events_baskets: 'Ostoskorissa ei ole tapahtumia.',
    sorry: 'Pahoittelut!',
    option_1: 'Vaihtoehto 1',
    option_2: 'Vaihtoehto 2',
    enter_number_words: 'Syötä suurin sallittu sanamäärä.',
    summarize: 'Yhteenveto',
    answer: 'Vastaus',
    hold_tight_one_minute:
      'Odota hetki! Valmistellaan edelleen. Tämä voi kestää jopa minuutin.',
    enter_question: 'Syötä kysymys.',
    enter_relevant_documents: 'Syötä asiaankuuluvien dokumenttien määrä.',
    please_input_relevant_documents: 'Syötä oikea määrä dokumentteja!',
    please_wait_loading_results: 'Odota tulosten latautumista...',
    proceed_to_add_voice: 'Jatka äänen lisäämistä',
    results: 'Tulokset',
    no_result_found_try_asking_questions:
      'Tuloksia ei löytynyt. Kokeile esittää lisää kysymyksiä.',
    eg: 'esim.',
    what_make_sales_manager: 'Miten minusta voi tulla myyntipäällikkö?',
    please_select_lang: 'Valitse kieli!',
    search: 'Haku',
    please_copy_desired_content:
      'Kopioi haluamasi sisältö vasemmasta laatikosta oikeaan.',
    rating_req: 'Arviointi on pakollinen kenttä.',
    review_req: 'Arvostelu on pakollinen kenttä.',
    rating_review_req: 'Sinun on annettava sekä arvio että arvostelu.',
    how_rate_this: 'Miten arvioisit tämän?',
    amazing_above_expectations: 'Mahtavaa! Ylitti odotukset!',
    certificates: 'Sertifikaatit',
    you_no_certificates: 'Sinulla ei ole sertifikaatteja tällä hetkellä.',
    please_add_review: 'Anna arvio ja arvostelu. Kiitos!',
    post: 'Julkaise',
    rate: 'Arvioi',
    avg_rating: 'Keskimääräinen arvio',
    no_review_found: 'Ei arvosteluja löytynyt',
    are_sure_to_disale_zoom_integration:
      'Haluatko varmasti poistaa Zoom-integraation?',
    badges: 'Merkit',
    you_no_badge_available:
      'Sinulla ei ole käytettävissä merkkejä tällä hetkellä.',
    download_certificate: 'Lataa sertifikaatti',
    loading: 'Ladataan...',
    no_file_attached: 'Tiedostoja ei ole liitetty',
    you_do_not_have_any_notes: 'Sinulla ei ole muistiinpanoja.',
    question: 'Kysymys',
    score: 'Pisteet',
    alert_score_message: 'Henkilö(t) ovat lähettäneet pistemääränsä.',
    alert_question_message: 'Kysymyksiä ei ole vielä lisätty.',
    button_submit: 'Lähetä',
    button_allScores: 'Kaikki pisteet on lähetetty.',
    record_wait: 'Tallennus alkaa. Odota hetki...',
    buttonSubmit_warning: 'Syötä kaikki pisteet ennen lähettämistä.',
    upload_ar_assets: 'Lataa AR-resurssit',
    edit_ar_assets: 'Muokkaa AR-resursseja',
    edit_maze_assets: 'Muokkaa MetaMaze-resursseja',
    upload_assets: 'Lataa resursseja',
    upload_maze_assets: 'Lataa MetaMaze-resursseja',
    trigger_title: 'Laukaisupään otsikko',
    model_title: 'Mallipään otsikko',
    trigger_description: 'Laukaisupään kuvaus',
    model_description: 'Mallipään kuvaus',
    please_type_target_description: 'Kirjoita kohteen kuvaus.',
    please_type_model_description: 'Kirjoita mallin kuvaus.',
    trigger_image: 'Laukaisupään kuva*',
    model_image: 'Mallin kuva*',
    upload_trigger_image: 'Lataa laukaisukuva',
    upload_model_image: 'Lataa mallikuva',
    drag_n_drop: 'Raahaa ja pudota',
    file_size_should_not_exceed:
      '(Kuvafileen (JPEG) koko ei saa ylittää 512 KB)',
    zip_size_should_not_exceed: '(Zip-tiedoston koko ei saa ylittää 60 MB)',
    ar_content: 'AR-sisältö*',
    model_content: '3D-malli*',
    upload_3d_zip: 'Lataa ZIP / Video',
    upload_3d_maze_zip: 'Lataa ZIP',
    audio_content: 'Äänisisältö',
    _mp3: '(.mp3)',
    content_attached: 'Zip-liite lisätty.',
    video_attached: 'Video-liite lisätty.',
    audio_attached: 'Ääniliite lisätty.',
    enter_trigger_image_title: 'Syötä laukaisukuvan otsikko.',
    enter_model_title: 'Syötä MetaMaze-mallin otsikko.',
    ar_preview_image: 'AR-esikatselukuva',
    upload_preview_image: 'Lataa esikatselukuva',
    upload_audio: 'Lataa ääni',
    creating___: 'Luodaan...',
    updating___: 'Päivitetään...',
    create: 'Luo',
    update: 'Päivitä',
    ar_assets: '3D-kuva',
    _3d_files_mp4: '(Pakattu .obj, .fbx tai .mp4-video)',
    _3d_files_mp4_ar: '(Pakattu .obj, .fbx)',
    maze_3d_files_mp4: '(Pakattu .obj, .fbx)',
    _jpg_files: 'Tukee vain .jpg-tiedostoja',
    persons_have_submitted_their_scores:
      'Henkilöt ovat lähettäneet pistemääränsä.',
    no_questions_added_till_now: 'Kysymyksiä ei ole lisätty vielä.',
    submit: 'Lähetä',
    all_scores_submitted: 'Kaikki pisteet on lähetetty.',
    recording_is_starting: 'Tallennus alkaa. Odota hetki…',
    please_input_scores_before_submitting:
      'Syötä kaikki pisteet ennen lähettämistä.',
    end_for_all: 'Lopeta kaikilta',
    full_screen: 'Koko näyttö',
    breakout_room: 'Jaoketila',
    send_invitations: 'Lähetä kutsut',
    add_participants: 'Lisää osallistujia',
    create_breakout_room: 'Luo jaoketila',
    connecting: 'Yhdistetään...',
    currently_broadcaster_unavailable: 'Lähettäjä ei ole saatavilla.',
    how_many_breakout_room_to_create: 'Kuinka monta jaoketilaa luoda?',
    create_upto_three_breakout_rooms: '*Luo enintään 3 jaoketilaa',
    allow: 'Salli',
    additional: 'Lisä',
    attachment: 'Liite',
    no_description_available: 'Kuvausta ei ole saatavilla.',
    people: 'Ihmiset',
    waiting: 'Odotetaan',
    hand_raising_users: 'Käyttäjät nostavat kättä',
    invite: 'Kutsu',
    create_room: 'Luo huone',
    create_live_event: 'Luo live-tapahtuma',
    support_upto_fivethousand_participants: 'Tukee jopa 5 000 osallistujaa',
    support_upto_ten_participants: 'Tukee jopa 10 live-​videon osallistujaa',
    support_upto_twohundred_participants:
      'Tukee jopa 200 osallistujaa tapahtumassa',
    supprt_upto_five_participants: 'Tukee jopa 5 live-​videon osallistujaa',
    support_upto_twentyfive_participants:
      'Tukee jopa 25 live-​videon osallistujaa tapahtumassa',
    two_live_video_participants:
      'On 2 live-​videon osallistujaa (isäntä ja osallistuja)',
    you_can_have_upto_five_examinees: 'Voit olla enintään 5 tutkittavaa.',
    you_can_have_upto_twentyfive_participants:
      'Voit olla enintään 25 osallistujaa.',
    you_can_have_upto_five_participants: 'Voit olla enintään 5 osallistujaa.',
    you_can_have_upto_ten_participants: 'Voit olla enintään 10 osallistujaa.',
    select_hosts_email: 'Valitse isännän sähköposti',
    send_invite_email: 'Lähetä kutsusähköposti',
    do_not_send_invite_email: 'Älä lähetä kutsusähköpostia',
    error: 'Virhe',
    max_twentyfive_users_allowed: 'Enintään 25 käyttäjää valittavissa',
    max_five_users_allowed: 'Enintään 5 käyttäjää valittavissa',
    max_ten_users_allowed: 'Enintään 10 käyttäjää valittavissa',
    no_user_found: 'Käyttäjää ei löydy',
    transcribe_to: 'Tekstiksi',
    integrate_zoom_to_start_meeting: 'Integroi Zoom aloittaaksesi kokouksen.',
    zoom_is_not_integrated: 'Zoom ei ole integroitu.',
    delete_poll: 'Poista kysely',
    add_poll: 'Lisää kysely',
    live_now: 'LIVE NYT!',
    average_rating: 'Keskimääräinen arvio',
    review: 'Arvostelu',
    time_spent: 'Käytetty aika',
    total: 'Yhteensä',
    mins: 'Minuuttia',
    no_data: 'Tietoja ei ole saatavilla.',
    total_score: 'Kokonaispisteet',
    pass_score: 'Hyväksymisraja',
    point: 'Piste',
    wrong: 'Väärin',
    response: 'Vastaus',
    submitted: 'Lähetetty',
    average: 'Keskimäärin',
    total_play: 'Kokonaiskäyttökerrat',
    view_graph: 'Näytä kaavio',
    time_spent_mins: 'Käytetty aika (minuuttia)',
    play: 'Pelaa',
    ideal_path: 'Ihanteellinen polku',
    user_incorrect_path: 'Käyttäjän virheellinen polku',
    ideal_path_taken: 'Käyttäjän ottama ihanteellinen polku',
    scenario: 'Skenaario',
    option: 'Vaihtoehto',
    spend: 'Käytä',
    average_spending_time: 'Keskimääräinen käyttöaika',
    activity_overview: 'Toiminnan yleiskatsaus',
    live_event: 'Live-tapahtuma',
    live_assessment: 'Live-arviointi',
    report_download: 'Lataa raportti',
    all_workshops: 'Kaikki työpajat',
    overview_average_activity: 'Toiminnan keskiarvokatsaus',
    overview_workshop_graph: 'Työpajan yleiskaavio',
    mazes: 'Labyrintit',
    correct_feedback: 'Oikea palaute',
    incorrect_feedback: 'Virheellinen palaute',
    checkin_checkout: 'Sisään – ulos',
    minutes: 'Minuutit',
    incorrect_path: 'Virheellinen polku',
    answer_not_available: 'Vastaus ei ole saatavilla',
    views: 'Katselut',
    item: 'Kohde',
    questions: 'Kysymykset',
    total_points: 'Kokonaispisteet',
    total_attempts: 'Yhteensä yrityksiä',
    created_date: 'Luontipäivämäärä',
    host_name: 'Isännän nimi',
    host_section: 'Isännän osio',
    choose_products: 'Valitse tuotteet',
    add_to_basket: 'Lisää koriin',
    basket: 'Ostoskori',
    times: 'Kerrat',
    scorms: 'SCORM-tiedostot',
    skill_journey_overview: 'Taitopolun yleiskatsaus',
    how_to_use: 'Kuinka käyttää',
    live_broadcast_description:
      'Olemme yhdistäneet LIVE‑VIDEON helppokäyttöiseen kurssinrakentajaan',
    live_broadcast_subdescription:
      'ShareLookin suojatun live-lähetysjärjestelmän avulla voit lisätä vuorovaikutusta, automatisoida oppimista ja maksimoida tiedonjaon.',
    disclaimer: `Vakuutan, että taitopolussani ei ole:
- kolmannen osapuolen oikeuksia loukkaavaa sisältöä
- lainvastaista materiaalia (esim. herjaava, epäsiveä, väkivaltainen tai syrjivä)
- henkilökohtaisiin hyökkäyksiin sisältöä
- toisen henkilön teeskennettyä identiteettiä
- henkilötietoja ilman suostumusta
- kaupallista mainontaa tai roskapostia`,
    price: 'Hinta',
    video_link: 'Videolinkki',
    category: 'Kategoria',
    objectives: 'Tavoitteet',
    marketplace_description: 'Markkinapalvelun kuvaus',
    live_discussion: 'LIVE-KESKUSTELU',
    poll: 'Kysely',
    hide_grid: 'Piilota ruudukko',
    show_grid: 'Näytä ruudukko',
    stop_screen_share: 'Lopeta näytönjako',
    screen_share: 'Näytönjako',
    mute: 'Mykistä',
    unmute: 'Poista mykistys',
    raise_hand: 'Nosta käsi',
    waiting__: 'Odotetaan...',
    audio_active: 'Ääni aktiivinen'
  },
  general: {
    save: 'tallenna',
    autosaved: 'tallennettu automaattisesti',
    back_to: 'takaisin',
    by: 'tekijältä',
    chat: 'chat',
    completed: 'valmis',
    canceled: 'Peruutettu',
    component: 'Komponentti',
    confirm: 'Vahvista',
    course: 'Kurssi',
    skill: 'Taitojen Matka',
    maze: 'MetaMaze',
    channel: 'Kanava',
    podcast: 'podcast',
    date: 'Päivämäärä',
    details: 'Lisätietoja',
    empty: 'Ei tietoja',
    enrolled: 'Osallistunut',
    free: 'Ilmainen',
    graph: 'Graafi',
    loading: 'Ladataan...',
    lesson: 'oppitunnit',
    lessons: 'oppitunnut',
    live_assessment: 'Live arviointi',
    live_event: 'Live tapahtuma',
    no: 'Ei',
    of: 'sta',
    or: 'tai',
    organization: 'Organisaatio',
    page: 'Sivu',
    pages: 'Sivut',
    personal: 'Henkilökohtainen',
    poll: 'Kysely',
    rating: 'Arviointi',
    reset: 'Nollaa',
    signin: 'Kirjaudu sisään',
    signup: 'Rekisteröidy',
    soon: 'Pian',
    type: 'Tyyppi',
    uploading: 'Ladataan...',
    yes: 'Kyllä',
    something_went_wrong: 'Jokin meni vikaan!',
    view_all: 'Näytä kaikki',
    upload_successful: 'Lataus onnistui',
    upload_successful_message:
      'Excel tiedostosi on ladattu onnistuneesti ja se prosessoidaan. Tähän saattaa mennä hetki.',
    check_email_upload_successful:
      'Tarkista <0>sähköpostiosoitteesi</0> <1>report</1> ladatussa käyttäjälistassa',
    is_private: 'Yksityinen'
  },

  account: {
    title: 'Tili',
    subtitle: 'Hallitse asetuksia ja tilin tietoja.',
    saved: 'Tili muutettu onnistuneesti'
  },

  assessments: {
    title: 'Arvioinnit',
    subtitle: 'Luo arviointi',
    finished: 'Arviointi on valmis',
    countdown: 'Live arviointi lähetetään ',
    create: 'Luo arviointi',
    list_title: 'Arviointisi',
    delete_warning: 'Haluatko varmasti poistaa tämän kohteen?',
    details_title: 'Lisää arvioinnin tiedot',
    details_subtitle:
      'Nimeä arviointisi ja kerro yleisöllesi mitä heidän tulee oppia siitä',
    disclaimer: `Takaan, että tallentamani arviointi ei riko:
- riko kolmannen osapuolen oikeuksia
- sisällä laitonta, loukkaavaa, julkeaa, epäsopivaa, pornografista, väkivaltaista, hyväksikäyttöistä, nimittelevää, uhkailevaa tai syrjivää sisältöä, edes asteriskeiksi naamioituneena
- sisällä henkilökohtaisia hyökkäyksiä toista ihmistä kohtaan
- sisällä toisia osallistujia esittävää sisältöä, mukana lukien julkiset henkilöt ja julkisuuden henkilöt
- sisällä tallenteita henkilökohtaisista tiedoista tai henkilöistä ilman heidän erillistä lupaansa, eikä riko minkään maailman osan tietosuojalakeja
- sisällä kaupallista sisältöä tai mitään ”spam” sisältöä'`,
    assessment_details: 'Arvioinnin tiedot',
    assessment_settings: 'Arvioinnin asetukset'
  },

  buildersettings: {
    title: 'Julkaise asetukset',
    subtitle: 'Lisää asetukset tapahtumaasi, ketkä voivat katsoa tapahtumaasi'
  },

  buttons: {
    market_place: 'Market Place',
    back_to_normal: 'Back To Normal',
    add: 'Lisää',
    add_page: 'Lisää sivu',
    add_lesson: 'Lisää oppitunnit',
    add_answer: 'Lisää uusi vastaus',
    add_group: 'Lisää ryhmä',
    add_organization: 'Lisää organisaatio',
    add_question: 'Lisää kysymys',
    add_quiz: 'Lisää kysely',
    add_users: 'Lisää käyttäjiä',
    back: 'Takaisin',
    back_to_course: 'Takaisin kurssin yleiskatsaukseen',
    back_to_lesson: 'Takaisin oppitunnin yleiskatsaukseen',
    back_to_media: 'Takaisin mediakirjastoon',
    back_to_details: 'Takaisin tietoihin',
    cancel: 'Peruuta',
    clear: 'Tyhjää',
    close: 'Sulje',
    clone: 'Kloonaa',
    close_lesson: 'Sulje oppitunti',
    clone_course: 'Kloonaa kurssi',
    confirm: 'Vahvista',
    create: 'Luo',
    download: 'Lataa',
    download_mass_user_tamplate: 'Lataa pohja',
    add_mass_users: 'Lisää massa käyttäjiä',
    upload_excel_list: 'Lataa Excel-lista',
    delete: 'Poista Media',
    edit: 'Muokkaa',
    edit_course: 'Muokkaa kurssia',
    enroll: 'Rekisteröidy',
    finish: 'Valmis',
    upload_image: 'Lataa kuva',
    upload_image_video: 'Lataa kuva tai video',
    select_media_library: 'Valitse mediakirjasto',
    make_public: 'Tee julkiseksi',
    make_private: 'Tee yksityiseksi',
    make_org: 'Tee organisaatio',
    media: 'Mediakirjasto',
    my_theme: 'Oma teema',
    next: 'Seuraava',
    next_lesson: 'Seuraava oppitunti',
    next_step: 'Seuraava vaihe',
    previous_step: 'Edellinen vaihe',
    publish: 'Julkaise',
    publish_assessment: 'Julkaise arviointisi',
    publish_course: 'Julkaise kurssisi',
    publish_event: 'Julkaise tapahtumasi',
    reset: 'Nollaa',
    reset_elements: 'Nollaa elementit',
    save: 'Tallenna',
    creating: 'Luodaan...',
    updating: 'Päivitetään...',
    saved: 'Tallennettu',
    save_for_later: 'Tallenna myöhemmäksi',
    save_settings: 'Tallenna asetukset',
    select_files: 'Valitse tiedostot',
    select_theme: 'Valitse teema',
    start_lesson: 'Aloita oppitunti',
    update: 'Päivitä',
    upload: 'Lataa',
    upload_audio: 'Lataa Audio',
    upload_photo: 'Lataa profiilikuva',
    upload_video: 'Lataa Video',
    enrolled: 'Rekisteröitynyt',
    unenroll: 'Peruuta rekisteröityminen',
    from_library: 'Mediakirjasto',
    remove: 'Poista',
    removed: 'Poistettu',
    start_broadcast: 'Aloita lähetys',
    end_broadcast: 'Lopeta lähetys',
    camera: 'Kamera',
    screen: 'Näyttö',
    screen_with_camera: 'Näyttö kameralla',
    insert: 'Syötä',
    inserting: 'Syötetään'
  },

  card: {
    quick_add: 'Pikalisäys',
    add: 'Lisää',
    clone: 'Kloonaa',
    completed: 'oppituntia suoritettu'
  },

  course: {
    upcoming_course: 'Tuleva kurssi',
    unPublishEvent: 'Peruuta tapahtuman julkaisu',
    unPublishAssessment: 'Peruuta arvioinnin julkaisu',
    pastCourse: 'Harjoittelukurssi',
    upcoming: 'Tuleva livetapahtuma',
    pastEvent: 'Mennyt livetapahtuma',
    pastAssessment: 'Mennyt Live arviointi',
    upcomingAssessment: 'Tuleva Live Arviointi',
    created: 'Luomispäivä:',
    assignees: 'Arvioitavat',
    organisations:
      ' {{ organisaatiot }} Organisaatiot, <2> {{ käyttäjät }} käyttäjät</2>',
    event_date: 'Livetapahtuman päivämäärä <1> {{ date }} </1>',
    delete_warning: 'Haluatko varmasti poistaa tämän',
    clonning_no_lesson:
      'Lisää vähintään yksi oppitunti kloonataksesi tämän kurssin.',
    clone_warning: 'Haluatko varmasti kloonata tämän',
    clone_success: 'kloonataan',
    disclaimer: `Takaan, että kurssini ei:
- riko kolmannen osapuolen oikeuksia
- sisällä laitonta, loukkaavaa, julkeaa, epäsopivaa, pornografista, väkivaltaista, hyväksikäyttöistä, nimittelevää, uhkailevaa tai syrjivää sisältöä, edes asteriskeiksi naamioituneena
- sisällä henkilökohtaisia hyökkäyksiä toista ihmistä kohtaan
- sisällä toisia osallistujia esittävää sisältöä, mukana lukien julkiset henkilöt ja julkisuuden henkilöt
- sisällä tallenteita henkilökohtaisista tiedoista tai henkilöistä ilman heidän erillistä lupaansa, eikä riko minkään maailman osan tietosuojalakeja
- sisällä kaupallista sisältöä tai mitään ”spam” sisältöä'`
  },

  coursecreate: {
    dropzone_text: 'Syötä media',
    sidebar_text: 'Valitse teema <1/>omalle<3/> oppitunnille',
    delete_warning: 'Haluatko varmasti poistaa tämän oppitunnin?'
  },

  coursepage: {
    quizview_loading: 'Tarkistetaan vastauksia. Odota...',
    quizview_answer: 'Vastauksesi'
  },

  coursequiz: {
    title: 'Kysymykset kaikissa oppitunneissa'
  },

  dashboard: {
    tooltip_title: 'Älä näytä tätä videota uudestaan',
    page_title: 'Kurssisi tilastot',
    page_subtitle: 'Luomiesi kurssien status',
    profile_add_info:
      'Lisää <1>{{uncompletedText}}</1> viimeistelläksesi profiilisi.',
    profile_build:
      'Rakenna profiilisi <1>täällä</1>, kerro meille kiinnostuksen kohteistasi ja taidoistasi.',
    profile_title: 'Profiilin vahvuus',
    more_details: 'Lisää tietoja'
  },

  errors: {
    answer: 'Syötä vastauksesi',
    answer_correct: 'Valitse oikea vastaus',
    code: 'Syötä koodisi',
    criterion: 'Syötä kriteeri',
    duration: 'Kesto vaaditaan',
    element: 'Syötä elementti',
    email: 'Syötä sähköpostiosoitteesi',
    email_invalid: 'Sähköposti ei ole kelvollinen',
    feedback_correct: 'Syötä palaute oikein',
    feedback_incorrect: 'Syötä palaute väärin',
    host: 'Syötä tapahtuman isäntä',
    host_assessment: 'Syötä arvioinnin isäntä',
    image: 'Syötä kuva',
    location: 'Syötä sijaintisi',
    live_location: 'Valitse lähetyksen sijainti',
    limit: 'Syötä livelähetyksen minuutit',
    min_3char: '3 merkkiä vähintään',
    number: 'syötä positiivisia numeroita.',
    host_email_require: `Isännän sähköpostit vaaditaan.`,
    attendee_email_require: `Osallistujan sähköpostit vaaditaan.`,
    name: 'Syötä nimesi',
    not_found_course: 'Kurssia ei löydy',
    not_found_event: 'Tapahtumaa ei löydy',
    not_found_assessment: 'Arviointia ei löydy',
    password: 'Syötä salasanasi',
    password_digit: 'Vähintään yksi numero',
    password_short: 'Salasana on liian lyhyt, vähintään 10 merkkiä',
    password_special: 'Vähintään yksi erikoismerkki',
    password_uppercase: 'Vähintään yksi iso kirjain',
    password_lowercase: 'Vähintään yksi pieni kirjain',
    phone: 'Syötä puhelimesi',
    phone_invalid: 'Puhelinnumero ei kelpaa',
    position: 'Syötä asemasi',
    question: 'Syötä kysymys',
    start_date: 'Aloitusaika vaaditaan',
    tag: 'Valitse tag',
    topics: 'Valitse vähintään yksi aihe.',
    live_topics: 'Lisää aiheet',
    title: 'Syötä otsikko',
    title_assessment: 'Syötä arvioinnin otsikko',
    title_course: 'Syötä kurssin otsikko',
    title_empty: 'Otsikko ei voi olla tyhjä',
    title_event: 'Syötä tapahtuman otsikko',
    title_lesson: 'Syötä oppitunnin otsikko',
    title_quiz: 'Syötä kyselyn nimi',
    username: 'Syötä käyttäjänimesi',
    invalid_verification_code: 'Tämä vahvistuslinkki on vanhentunut tai ei ole enää voimassa. Tämä tapahtuu yleensä, jos uudempi vahvistussähköposti on pyydetty. Tarkista Sharelookin lähettämä uusin sähköposti sähköpostiosoitteesi vahvistamiseksi.',
    upload_error: 'Error – Tiedosto ei ole yhteensopiva!',
    upload_more_than_10: 'Voit ladata korkeintaan 10 tiedostoa kerrallaan.',
    topics_max: 'Lisää korkeintaan 3 aihetta.',
    upload_excel: 'Varmista, että olet ladannut oikean tiedoston.',
    title_excel: 'Virhe pohjan lataamisessa:',
    file_size_exceed: 'Tiedostokoko ylitetty',
    subtitle_excel:
      'Varmista, että käytät annettua pohjaa ja että sarakkeet ovat oikein.',
    select_broadcast_option: 'Valitse lähetystapa tapahtumalle',
    multi_hosts_number_error:
      'Esittäjien määrä ei saa ylittää tapahtumassa määritettyä.',
    conference_people_number_error: `Osallistujien määrä ei saa ylittää tapahtumassa määritettyä määrää.`,
    select_max_host: 'Valitse vähintään 1 esittäjä tapahtumalle.',
    select_max_conference: 'Valitse vähintään 1 osallistuja tapahtumaan.',
    stream_stop_error: 'Lähetys loppui odottamattomasti!',
    unsecure_context:
      'Fatal Error: Selain ei voi käyttää kameraa ja mikrofonia epävarmojen olosuhteiden takia. Asenna SSL ja käytä hhhtps-yhteyttä',
    ws_not_supported: 'Fatal Error: WebSocket ei tuettu tällä selaimella',

    no_org: 'Valitse vähintään 1 organisaatio jatkaaksesi.',
    no_org_group: 'Valitse vähintään 1 organisaatioryhmä jatkaaksesi.',
    waiting_to_join: 'Odotetaan jonkun liittymistä!'
  },

  events: {
    title: 'Lisää livetapahtuman tiedot',
    change_host: 'Vaihda isäntää',
    finished: 'Tapahtuma on valmis',
    countdown: 'Livetapahtuma lähetetään ',
    subtitle:
      'Nimeä tapahtumasi ja kerro yleisölle mitä heidän pitäisi odottaa.',
    poll_disabled: 'Kysely ei saatavilla tässä tapahtumassa',
    disclaimer: `Takaan, että tallentamani tapahtuma ei:
- riko kolmannen osapuolen oikeuksia
- sisällä laitonta, loukkaavaa, julkeaa, epäsopivaa, pornografista, väkivaltaista, hyväksikäyttöistä, nimittelevää, uhkailevaa tai syrjivää sisältöä, edes asteriskeiksi naamioituneena
- sisällä henkilökohtaisia hyökkäyksiä toista ihmistä kohtaan
- sisällä toisia osallistujia esittävää sisältöä, mukana lukien julkiset henkilöt ja julkisuuden henkilöt
- sisällä tallenteita henkilökohtaisista tiedoista tai henkilöistä ilman heidän erillistä lupaansa, eikä riko minkään maailman osan tietosuojalakeja
- sisällä kaupallista sisältöä tai mitään ”spam” sisältöä'`,
    prompt_message:
      'Tältä sivulta lähteminen lopettaa tapahtumasi. Haluatko varmasti lähteä tältä sivulta?',
    duration_exceed_message:
      'Lähetyksesi aika ylittyi, Sovellus sulkee lähetyksen.',
    before_schedule_message:
      'Olet aloittamassa lähetyksen ennen ajastettua aikaa. Ota huomioon, että lähetyksen lopettaminen ei lopeta tapahtumaa.',
    browser_unsupportive_message:
      'Selaimesi ei tue näytön jakamista. Voit nähdä tuetut selaimet tästä linkistä',
    cancel_switch_host_message:
      'Isäntä ei ole saatavilla. Tapahtuma jatkuu sinun kauttasi.',
    coaching_prompt_message:
      'Et voi lähteä tältä sivulta, ennen kuin tapahtuma on loppunut.',
    event_modal_warn: 'Haluatko lähteä tästä tapahtumasta?',
    confirm_message: 'Tapahtumasi päättyy, jos painat OK.',
    screen_share_denied: 'Kieltäydyit ruudun jakamisesta',
    media_not_found:
      'Kameraa tai mikrofonia ei löydy tai ole sallittu laitteellasi.',
    media_not_access:
      'Kamera tai mikrofoni on jonkin toisen prosessin käytössä',
    constraint_error:
      'Saatavilla ei ole laitetta, joka sopii video ja audio vaatimuksiin. Voit muuttaa video ja audio vaatimuksia',
    media_access_denied: 'Sinulla ei ole lupaa käyttää kameraa ja mikrofonia.'
  },

  filters: {
    days7: 'Viimeiset 7 päivää',
    days15: 'Viimeiset 15 päivää',
    days30: 'Viimeiset 30 päivää',
    days365: 'Viimeiset 365 päivää',
    date: 'Luomispäivä',
    relevance: 'Sopivuus',
    popularity: 'Suosio',
    name: 'Nimi',
    group: 'Ryhmä',
    Newest_to_Oldest: 'Uusimmasta vanhimpaan',
    Oldest_to_Newest: 'Vanhimmasta uusimpaan',
    A_Z: 'A - Z',
    Z_A: 'Z - A'
  },

  helpers: {
    password:
      'Taataksesi tilisi turvallisuuden, vaadimme vähintään yhden pienen kirjaimen ja numeron salasanassasi. Salasanan pituus on myös oltava vähintään 10 merkkiä.',
    phone: 'Laita puhelinnumeroon maakohtainen numero, esimerkiksi: +65',
    username:
      'Käyttäjänimeäsi pidetään julkisena tietona ja se voidaan jakaa muille tarpeen vaatiessa. Emme suosittele laittamaan henkilökohtaisia tietoja käyttäjänimeesi',
    public_description_normal:
      'Sinun <0><0/></0> on tallennettu ja sitä käsitellään oletuksena yksityisenä. Tämä tarkoittaa sitä, että vain sinä voit nähdä tämän sisällön. Julkaistaksesi tämän sisällön, valitse yksi alla olevista vaihtoehdoista. Kurssisi asettaminen julkiseksi tarkoittaa sitä, että kaikki alustan käyttäjät voivat käyttää sitä. Tiettyjen käyttäjien asetukset mahdollistavat kurssin jakamisen tietyille käyttäjille Sharelook-sähköpostin kautta.',
    public_description_admin:
      'Tämä <0><0/></0> on tallennettu ja sitä pidetään oletuksena Yksityisenä. Tämä tarkoittaa sitä, että vain sinä (ja sisällön tuottaja) näkevät tämän sisällön. Julkaistaksesi tämän sisällön, valitse yksi alla olevista vaihtoehdoista. Kurssisi asettaminen julkiseksi tarkoittaa sitä, että kaikki alustan käyttäjät voivat käyttää sitä – mukaan lukien organisaatiosi jäsenet. Organisaatiolle julkaiseminen tarkoittaa, että kaikki organisaation jäsenet näkevät sisällön- Voit myös julkaista 1 tai useammalle ryhmälle, tarkoittaen, että vain näiden ryhmien jäsenet näkevät sen. Voit myös julkaista tietyille käyttäjille organisaatiosi sisällä ja sen ulkopuolella käyttämällä heidän Sharelook-sähköpostiosoitetta.'
  },

  labels: {
    add: 'Lisää',
    portrait: 'Crop Portrait',
    landscape: 'Crop Landscape',
    answer_type: 'Vastauksen tyyppi',
    answers: 'Vastaukset',
    back_to_quiz: 'Takaisin kyselylistaan',
    back_to_question: 'Takaisin kysymyslistaan',
    chat: 'Chat',
    chat_available: 'Chat ei ole saatavilla tässä tapahtumassa',
    chat_report: 'Chat Report',
    choice_single: 'Yksivalinta',
    choice_multiple: 'Monivalinta',
    choice_free: '"Vapaa" valinta',
    choice_sorting: '"Lajittelu" valinta',
    choice_matrix: '"Matrix lajittelu" valinta',
    clone_lesson_permission: 'Kloonaa lupa',
    code: 'Koodi',
    correct: 'Oikein',
    created: 'Luomispäivä',
    clone_modal: 'Kloonaa kurssi',
    cloning_course: 'Kloonataan kurssia...',
    cloning: 'Kloonataan...',
    cloning_course_desc: 'Tähän prosessiin kuluu hetki. Odota kärsivällisesti.',
    cloning_success: 'Kurssi "<0/>" on kloonattu onnistuneesti!',
    description: 'Kuvaus',
    disclaimer: 'Disclaimer',
    drop_file: 'Pudota tiedosto tähän...',
    duration: 'Kesto',
    edit: 'Muokkaa',
    email: 'Sähköposti',
    event: 'Tapahtuma',
    event_all: 'Kaikki tapahtumat',
    event_date: 'Live Livetapahtuman päivä/aika',
    event_this: 'Tämä tapahtuma',
    expire: 'Voimassaolo lakkaa',
    expiry_date: 'Eräpäivä',
    forgot: 'Unohditko salasanan?',
    group: 'Ryhmä',
    groups_list: 'Ryhmien lista',
    host: 'Isäntä',
    id_annotation: 'Merkinnän id',
    id_quiz: 'Kyselyn id',
    incorrect: 'Väärin',
    interests: 'Kiinnostuksen kohteet',
    invited: 'Kutsuttu',
    live_chat: 'Live Keskustelu',
    live_stream_limit: 'Live-lähetyksen minuutit',
    contact_text:
      'Vaihtaaksesi kuukausittaista lähetysrajaa, valitse ota yhteyttä',
    contact_admin:
      '<0>Jos haluat muuttaa kuukausittaista livelähetyksen rajaa, ota yhteyttä y</0> <1>admin@sharelook.com</1>',
    limit_stream_text:
      'Live-lähetyksen minuutteja jäljellä: <0>{{ limit }}</0> minuuttia <1/><2/> <3>Vaihtaaksesi kuukausittaista lähetysrajaa, valitse ota yhteyttä</3> <4>admin@sharelook.com</4>',
    location: 'Sijainti',
    lessons: 'Oppitunnit',
    location_broadcast: 'Isännän palvelimen sijainti',
    location_broadcast_subtitle:
      'Lisää sijainti, joka on lähimpänä isännän sijaintia vähentääksesi viivettä',
    media_manager: 'Media manager',
    minutes: 'Minuuttia',
    name: 'Nimi',
    online_quiz: 'Online Quiz',
    organiser: 'Tekijä',
    organization: 'Organisaatio',
    overall_emotion: 'Yleinen kokemus:',
    organizations_list: 'Lista organisaatioista',
    password: 'Salasana',
    participants: 'Osallistujat',
    picture: 'Kuva (16:9)',
    phone: 'Puhelin',
    photo: 'Kuva',
    poll: 'Kysely',
    position: 'Sijainti',
    processing: 'Prosessoidaan',
    privacy_settings: 'Yksityisyysasetukset',
    question: 'Kysymys',
    quiz_create: 'Luo uusi kysely',
    quiz_name: 'Kyselyn nimi',
    quiz_update: 'Päivitä kysely',
    select_organization: 'Valitse organisaatio',
    settings: 'Asetukset',
    show: 'Näytä',
    show_graph: 'Näytä graafin tulos',
    signin: 'Kirjaudu sisään',
    signup: 'Rekisteröidy',
    sort_by: 'Järjestä',
    start_date: 'Alkamispäivä',
    tags: 'Tagit',
    terms: 'Hyväksyn nämä <1>käyttöehdot</1>.',
    title: 'Otsikko',
    topics: 'Aiheet',
    topic: 'Aihe',
    total_comments: 'Kommentteja yhteensä',
    username: 'Käyttäjänimi',
    users_list: 'Käyttäjälista',
    users_emails: 'Syötä tiettyjen käyttäjien sähköpostit',
    description_specifiction_email:
      'Syötä yksi kelvollinen sähköpostiosoite per linja jakaaksesi monelle käyttäjälle.',
    message_specific_email: 'Anna tietyn käyttäjän sähköpostiosoite.',
    viewers: 'Katsojat',
    edit_course: 'Muokkaa',
    edit_assessment: 'Muokkaa',
    edit_event: 'Muokkaa',
    delete_course: 'Poista',
    delete_event: 'Poista',
    delete_assessment: 'Poista',
    view_course: 'Näytä',
    view_event: 'Näytä',
    view_assessment: 'Näytä',
    date_event: 'Live tapahtuman päivämäärä',
    date_assessment: 'Live arvioinnin päivämäärä',
    clone_of: 'Kloonaa',
    clone_course:
      'Luo klooni tästä kurssista, jota voit muokata itsenäisesti, mukaan lukien oppitunnit ja sivut.',
    make: 'Tee',
    available_to: 'saatavilla kaikille ShareLook käyttäjille',
    uploaded_by: 'Lataaja: ',
    course: 'Kurssi',
    assessment: 'Arviointi',
    user_not_exist: 'Käyttäjää ei ole olemassa, haluatko lähettää kutsun?',
    check_user: 'Huomautus',
    user_not_exist_in_org:
      'Käyttäjää ei ole olemassa organisaatiossa, haluatko lähettää kutsun?',
    title_modal_stream: 'Muuta organisaation livelähetysrajaa',
    des_warning_stream: 'Olet muuttamassa',
    monthly_stream: 'kuukausittaista livelähetysten rajaa:',
    min_per_month: 'minuuttia/kuukausi',
    broadcast_label: 'Haluan tehdä:',
    hosts_emails: `Syötä tiettyjen isäntien sähköpostit`,
    attendee_emails: `Syötä tiettyjen osallistujien sähköpostit`,
    description_host_specifiction_email:
      'Syötä yksi sähköpostiosoite per linja.',
    presenter_label: 'Esittäjä',
    presenter_label_conference: 'Ihmisten määrä',
    event_privacy: 'Konferenssitila'
  },

  broadcastOptions: {
    stream_from_phone: 'Live lähetys puhelimellani',
    other_webrtc: 'Webinaari tietokoneeltani',
    multihost: 'Multicast webinaari tietokoneeltani',
    peer2peer: 'Koulutussessio',
    conference: 'Live konferenssi'
  },

  lessoncreate: {
    title: 'Lisää oppitunnin tiedot',
    subtitle: 'Nimeä oppituntisi ja kerro yleisölle mitä haluat oppia.',
    input_label_title: 'Oppitunnin otsikko',
    input_label_topics: 'Oppitunnin aiheet',
    input_label_description: 'Oppitunnin kuvaus',
    delete_warning: 'Haluatko varmasti poistaa tämän sivun?'
  },

  lessonoverview: {
    title: 'Lisää oppitunti',
    subtitle: 'Lisää olemassa oleva oppitunti tai luo uusi',
    new_lesson: 'luo uusi oppitunti',
    new_lesson_sub: 'Luo uusi oppitunti alusta!',
    existing_lesson: 'Valitse olemassa oleva oppitunti',
    existing_lesson_sub:
      'Yhdistä olemassa olevaan oppituntiin, muutokset vaikuttavat muihin kursseihin.',
    clone_lesson: 'kopioi olemassa oleva oppitunti',
    clone_lesson_sub:
      'Tee uniikki kopio tästä kurssita, tämän kurssin muutokset eivät vaikuta alkuperäiseen versioon.',
    clone_lesson_modal_sub:
      'Klikkaa kloonausnappia sen oppitunnin alla, jonka haluat lisätä kurssille.'
  },

  management: {
    groups_title: 'Hallitse ryhmiä',
    delete_warning: 'Oletko varma?',
    organizations_title: 'Organisaationi',
    organizations_subtitle: 'Lisää organisaatio listaasi',
    users_title: 'Hallitse käyttäjiä',
    users_position: 'Senior Account Manager',
    user_not_found: 'Käyttäjää ei löydy',
    select_org: 'Valitse organisaatio hallitaksesi käyttäjiä'
  },

  audio: {
    modal_title: 'Syötä Audio',
    list_view: 'Listanäkymä',
    create_audio_modal_title: 'Luo Audio',
    edit_audio_modal_title: 'Muokkaa Audio',
    public_audio_not_found: 'Audio ei löydy.',
    private_audio_not_found: 'Et ole ladannut Audio tiedostoja',
    are_you_sure_to_delete: 'Haluatko varmasti poistaa?',
    type_something: 'Kirjoita jotain',
    select_voice: 'Valitse',
    file_name: 'Tiedoston nimi',
    description: 'Kuvaus',
    topic: 'Aihe',
    key_words_tag: 'Avainsanat Tag',
    mp3_audio: 'MP3 Audio',
    created: 'Luotu',
    duration: 'Kesto',
    close: 'sulje'
  },

  image: {
    modal_title: 'Syötä kuva',
    image: 'Kuva',
    pixel: 'Pikseli',
    dimension: 'Pituus',
    public_image_not_found: 'Kuvaa ei löydy.',
    private_image_not_found: 'Et ole vielä ladannut kuvaa'
  },

  annotation: {
    modal_title: 'Merkintä'
  },

  text: {
    modal_title: 'Tekstieditori'
  },

  video: {
    modal_title: 'Syötä Video',
    image: 'Video',
    mp4_video: 'MP4 Video',
    public_video_not_found: 'Video ei löytynyt.',
    private_video_not_found: 'Et ole vielä ladannut videoita'
  },

  media: {
    title: 'Mediakirjasto',
    subtitle: 'Tiedostojesi kirjasto',
    modal_title: 'Lataa media',
    delete_warning: 'Vahvista poisto',
    delete_message:
      'Poistettu media näkyy silti sivuilla, joissa sitä on käytetty',
    dropzone_text: 'tai raahaa ja pudota',
    delete_success: 'Media on poistettu onnistuneesti',
    upload_file: 'Lataa tiedosto',
    drag_drop: 'tai raahaa ja pudota',
    import_file: 'Tuo tiedosto(t) tietokoneeltasi',
    no_media: 'Et ole vielä ladannut mediaa',
    media_type: 'Median tyyppi',
    video: 'Video',
    image: 'Kuva',
    audio: 'Audio',
    gif: 'GIF',
    transcribed_text: 'Transcribed Text',
    media_not_found: 'Mediaa ei löytynyt.',
    of: 'paikasta',
    disclaimer: `Takaan, että mediani ei:
- riko kolmannen osapuolen oikeuksia
- sisällä laitonta, loukkaavaa, julkeaa, epäsopivaa, pornografista, väkivaltaista, hyväksikäyttöistä, nimittelevää, uhkailevaa tai syrjivää sisältöä, edes asteriskeiksi naamioituneena
- sisällä henkilökohtaisia hyökkäyksiä toista ihmistä kohtaan
- sisällä toisia osallistujia esittävää sisältöä, mukana lukien julkiset henkilöt ja julkisuuden henkilöt
- sisällä tallenteita henkilökohtaisista tiedoista tai henkilöistä ilman heidän erillistä lupaansa, eikä riko minkään maailman osan tietosuojalakeja
- sisällä kaupallista sisältöä tai mitään ”spam” sisältöä'`,
    my_media: 'Oma Media',
    public_library: 'Julkinen kirjasto',
    organization_library: 'Organisaation kirjasto',
    upload_from_computer: 'Lataa tietokoneesta',
    create: 'Luo',
    all: 'Kaikki',
    male: 'Mies',
    female: 'Nainen',
    processing_audio: 'Prosessoidaan Audiota',
    create_annotation: 'Luo merkintä',
    popup_over_lesson_text:
      'Merkinnät ilmestyvät sivun ylälaitaan klikkauksen jälkeen',
    edit_detail: 'Muokkaa tietoja',
    delete: 'Poista',
    go_create_audio: 'Luo Audio',
    show_more_details: 'näytä lisää tietoja',
    show_less_details: 'näytä vähemmän tietoja',
    drop_files: 'Pudota tiedostot ja minne ladata',
    or: 'Tai',
    import_files: 'Tuo tiedostot tietokoneelta'
  },

  navigation: {
    account: 'Tili',
    assessments: 'Arvioinnit',
    dashboard: 'Etusivu',
    groups: 'Ryhmähallinta',
    logout: 'Kirjaudu ulos',
    organisations: 'Organisaatiot',
    organizations_users: 'Organisaatiot ja käyttäjät',
    reports: 'Raportit',
    schedule: 'Aikataulu',
    training: 'Harjoittelu',
    users: 'Käyttäjät',
    workshop: 'Oma Workshop',
    nowLive: 'lähetetään nyt'
  },

  onboarding: {
    step1_title: 'Vaihe 1 : Kerro meille itsestäsi',
    step1_subtitle: 'Mikä on nimesi? Mistä tulet? Mikä on työnkuvaus?',
    step2_title: 'Vaihe 2 : Valitse taidot, joita haluat parantaa',
    step2_subtitle:
      'Seuraavaksi, kerro meille mitä haluat ymmärtää paremmin. Ehkä jotain uutta? Uusi ala? Mitä lähimmäisesi tekee?'
  },

  pagebuilder: {
    title: 'Luo oppitunti',
    subtitle:
      'Aika luoda sisältöä yleisöllesi, jotta he voivat tuntea sinut. Voit laittaa kuvia, videoita tai infografeja',
    select_layout: 'Valitse sivun asettelu',
    template1: 'Tyhjä',
    template2: 'Otsikko & alaotsikko ',
    template3: ' Otsikko & Teksti',
    template4: 'Otsikko, Media & Teksti',
    template5: ' Otsikko & Media',
    template6: ' Otsikko & Kysely'
  },

  pageconstructor: {
    title: 'Luo ja kloonaa oppitunti',
    subtitle:
      'Aika luoda sisältöä yleisöllesi, jotta he voivat tuntea sinut. Voit laittaa kuvia, videoita tai infografeja'
  },

  passwordreset: {
    success_coded:
      'Olemme lähettäneet vahvistusviestin antamaasi osoitteeseen, kopioi koodi alla olevaan kenttään asettaaksesi uuden salasanan.',
    success_changed:
      'Olet asettanut uuden salasanan onnistuneesti. Voit nyt kirjautua sisään.'
  },

  placeholders: {
    search: 'Etsi',
    answer: 'Vastaa',
    chat: 'Sano jotain...',
    code: 'Koodi',
    criterion: 'Kriteeri',
    date_event: 'Valitse aika',
    date_start: 'Aloitusaika',
    date_expire: 'Voimassaoloaika',
    description: 'Kuvaus',
    elements: 'Lajittele elementit',
    email: 'Sähköpostiosoite',
    feedback_correct: 'Palaute oikein',
    feedback_incorrect: 'Palaute väärin',
    host: 'Isäntä',
    keywords: 'Etsi avainsana(t)',
    lesson_description: 'Oppitunnin kuvaus',
    location: 'Sijainti',
    minutes: 'Minuuttia',
    name: 'Nimi',
    organiser: 'Tekijä',
    organization: 'Organisaatio',
    password: 'Salasana',
    phone: 'Puhelin',
    photo: 'Kuva',
    picture: 'Kuva',
    point: 'Piste',
    position: 'Sijainti',
    question: 'Kysymys',
    quiz: 'Kyselyn nimi',
    search_course: 'Etsi kurssin mukaan',
    search_media: 'Etsi media',
    search_name: 'Etsi nimen mukaan',
    search_title: 'Etsi otsikon mukaan',
    search_training: 'Etsi harjoittelu',
    settings: 'Asetukset',
    tags: 'Tagit',
    title: 'Otsikko',
    topics: 'Aiheet',
    username: 'Käyttäjänimi',
    keyword: 'Avainsanat',
    max_500_characters: 'Max 500 merkkiä ',
    no_description: 'Tällä tiedostolla ei ole kuvausta',
    no_keyword: 'Tämä tiedosto ei tue avainsanoja',
    no_topics: 'Tällä tiedostolla ei ole aihetta',
    feedback: 'Viesti',
    contact: 'Miten voimme auttaa?'
  },

  publishsettings: {
    title: 'Julkaise asetukset',
    event_subtitle:
      'Lisää uusi asetus tapahtumaan, kuka voi katsoa ja osallistua tapahtumaan',
    assessment_subtitile:
      'Nimeä arviointisi ja kerro yleisölle, mitä heidän tulee oppia siitä',
    course_subtitle:
      'Lisää asetus kurssiin, kuka voi katsoa ja osallistua kurssiin',
    disclaimer: `1. Rekisteröinti

    Rekisteröimällä tilin hyväksyt meidän [Käyttäjäsopimuksen] ja olet lukenut [Yksityisyydensuojakäytäntö]



    2. Luo kurssi

    Käyttämällä työkalujamme ja luomalla sisältöä, hyväksyt [Käyttäjäsopimuksen] ja olet lukenut [Yksityisyydensuojakäytäntö]



    3. Luo tapahtuma

    Käyttämällä työkalujamme ja luomalla sisältöä, hyväksyt [Käyttäjäsopimuksen] ja olet lukenut [Yksityisyydensuojakäytäntö]


    4. Luo arviointi

    Käyttämällä työkalujamme ja luomalla arvioinnin, hyväksyt [Käyttäjäsopimuksen] ja olet lukenut [Yksityisyydensuojakäytäntö] `,
    dates_validation_error: 'Molemmat päivämäärät tulee syöttää.',
    course_dates_validation_error: 'Anna tämän kurssin alkamis- ja päättymispäivä.',
    emails_validation_error: 'Sähköpostilista on väärin.',
    specific_email_validation_error: 'Vain yksi sähköpostiosoite sallitaan.',
    i_agree_to_these: 'Hyväksyn nämä ',
    terms_and_conditions: 'käyttöehdot.',
    PublicDescription:
      'Ilmaiset itsenäiset käyttäjät: (yksityiset ja julkiset vaihtoehdot) Teidän [Course|Event|Assessment] on tallennettu ja sitä pidetään yksityisenä oletuksella. Tämä tarkoittaa sitä, että vain sinä voit nähdä tämän sisällön. Julkaistaksesi tämän sisällön, voit valita tehdä siitä julkisen alapuolella. Tämä tarkoittaa sitä, että kaikki alustan käyttäjät näkevät sisällön.',
    OrganisationsDescription:
      'Organisaatiokäyttäjät: ( ""Valmis"" sijaan käytä ""Julkaise"" ja tuo heidän julkaise sivulle kuten muutkin käyttäjät, mutta ilman julkaisvaihtoehtoja.) Sinun [Course|Event|Assessment] on tallennettu ja se on yksityinen. Tämä tarkoittaa sitä, että vain sinä ja organisaation järjestelmänvalvojat voivat nähdä sen. Käyttäjänä et voi julkaista tätä sisältöä organisaatiossa itsenäsi, koska se vaatii järjestelmänvalvojan oikeuksia. Ota yhteyttä järjestelmänvalvojaan ja pyydä heitä julkaisemaan sisällöt julkisesti koko organisaatiolle, tietyille ryhmille, tietyille ryhmille organisaatiossa tai tietyille käyttäjille.',
    OrganisationGroupsDescription:
      'Org Adminit: (Organisaation sisällä tehdylle sisällölle: Yksityinen, julkinen, organisaatio, ryhmät, tietyt käyttäjät): Tämä [Course|Event|Assessment] on tallennettu ja sitä pidetään yksityisenä oletuksella. Tämä tarkoittaa sitä, että vain sinä voit nähdä tämän sisällön. Julkaistaksesi tämän sisällön, valitse yksi alla olevista vaihtoehdoista. Kurssin julkaiseminen Julkiseksi tarkoittaa sitä, että kaikki alustan käyttäjät näkevät sen – mukaan lukien organisaation ulkopuoliset käyttäjät. Organisaatiolle julkaiseminen tarkoittaa sitä, että kaikki organisaation jäsenet näkevät sen. Voit myös julkaista sen 1 tai useammalle ryhmälle, tarkoittaen, että näissä ryhmissä olevat jäsenet voivat nähdä sen. Viimeiseksi, sinulla on vaihtoehto julkaista se tietyille käyttäjille organisaatiossasi ja sen ulkopuolella käyttämällä heidän Sharelook -tilinsä sähköpostiosoitetta.',
    SpecificUsersDescription:
      'Maksetut yksityiset käyttäjät: (yksityinen, julkinen ja tietyt käyttäjät) Teidän [Course|Event|Assessment] on tallennettu ja sitä pidetään yksityisenä oletuksella. Tämä tarkoittaa sitä, että vain sinä voit nähdä tämän sisällön. Julkaistaksesi tämän sisällön, valitse yksi alla olevista vaihtoehdoista. Kurssin julkaiseminen Julkiseksi tarkoittaa sitä, että kaikki alustan käyttäjät näkevät sen. Tietyt käyttäjät -vaihtoehto tarkoittaa sitä, että voit jakaa kurssin tietyille käyttäjille heidän Sharelook -tilinsä sähköpostiosoitteen kautta.'
  },

  quiz: {
    quiz_empty: 'Et ole vielä luonut kyselyä',
    questions_empty: 'Et ole vielä luonut kysymystä'
  },

  regions: {
    asia_pacific_australia: 'Australia',
    asia_pacific_india: 'Intia',
    asia_pacific_japan: 'Japani',
    asia_pacific_s_korea: 'Etelä-Korea',
    asia_pacific_singapore: 'Singapore',
    asia_pacific_taiwan: 'Taiwan',
    eu_belgium: 'Belgia',
    eu_germany: 'Saksa',
    eu_ireland: 'Irlanti',
    south_america_brazil: 'Brasilia',
    us_central_iowa: 'Iowa',
    us_east_s_carolina: 'Etelä-Carolina',
    us_east_virginia: 'Virginia',
    us_west_california: 'Kalifornia',
    us_west_oregon: 'Oregon'
  },

  reports: {
    title: 'Raportit',
    workshop_report: 'Työpajan raportti',
    user_report: 'Käyttäjäraportti',
    organization_workshop: 'Organisaation työpaja',
    course: 'Kurssi',
    live_event: 'Live tapahtuma',
    workShop_graph: 'Työpajan graafi',
    organization_account: 'Organisaation tili',
    all: 'Kaikki',
    name: 'Nimi',
    id_number: 'ID Numero',
    email: 'Sähköpostiosoite',
    search_user_report: 'Etsi käyttäjäraportti',
    participant: 'Osallistuja',
    participants: 'Osallistujat',
    host: 'Isäntä',
    username: 'Käyttäjä',
    event: 'Tapahtuma',
    quiz: 'Kysely',
    assessment: 'Arviointi',
    time: 'Aika',
    no_recent_activity: 'Ei viimeaikaista toimintaa',
    workshops: 'Työpajat',
    courses: 'Kurssit',
    live_events: 'Livetapahtumat',
    live_assessments: 'Livearvioinnit',
    quizzes: 'Quizzes',
    overview: 'Yleiskatsaus',
    by: 'Tekijältä',
    views: 'Näyttökerrat',
    status: 'Tila',
    poll: 'Äänestys',
    comment: 'Kommentti',
    comments: 'Kommentit',
    no_comments: 'Ei kommentteja',
    no_polls: 'Ei äänestyksiä',
    live_date: 'Live päivämäärä',
    score: 'Pisteet',
    question: 'Kysymys',
    submit: 'Lähetä',
    recent_activity: 'Viimeaikainen toiminta',
    ago: 'Sitten',
    no_data_found: 'Tietoja ei löytynyt',
    start_end_live: 'Aloita/Lopeta live',
    join_leave_date: 'Liity / Lähde',
    watched_time: 'Katsottu aika',
    complete: 'Valmis',
    in_complete: 'Valmiissa',
    today: 'Tänään',
    seven_days: '7 Päivää',
    last_month: 'Viime kuukausi',
    one_year: '1 Vuosi',
    all_time: 'Koko ajan',
    report: 'Raportti',
    from_date: 'Päivästä',
    to_date: 'Päivään',
    all_workshop: 'Kaikki workshopit',
    all_participants: 'Kaikki osallistujat',
    live_assessment: 'Live arvioinnit',
    users: 'Käyttäjät',
    download: 'Lataa',
    recent: 'Viimeaikainen',
    WorkShop: 'Workshop',
    Activity: 'Toiminta',
    created_date: 'Luomispäivä',
    lessons: 'Oppitunnit',
    lesson: 'Oppitunti',
    completed: 'Suoritettu',
    report_download: 'Raportoi lataus',
    this_month: 'Tässä kuussa',
    search_course: 'Etsi kurssista',
    participants_graph: 'Osallistujien tilasto',
    viewed: 'Katsottu',
    enrolled: 'Rekisteröity',
    description: 'Kuvaus',
    topic: 'Aihe',
    analytic: 'Tilasto',
    quiz_list: 'Kyselylista',
    select_one: 'Valitse yksi',
    group_status: 'Ryhmän status',
    duration_min: 'Kesto(min)',
    submit_poll: 'Lähetä kysely',
    download_events: 'Lataa tapahtumat',
    search_event: 'Etsi tapahtumasta',
    duration: 'Kesto',
    total_participants: 'Osallistujia yhteensä',
    message: 'Viesti',
    avg_message: 'Avg. Viesti',
    per_message: 'PROSENTTIOSUUS VIESTEISTÄ / TAPAHTUMASTA'
  },

  signup: {
    success_step1:
      'Olemme lähettäneet vahvistuskoodin antamaasi sähköpostiosoitteeseen. Kopioi koodi alla olevaan kenttään vahvistaaksesi rekisteröitymisen.',
    success_step2: 'Kiitos. Olet rekisteröitynyt onnistuneesti.',
    privacy: `Hyväksyn Sharelookin <1> käyttöehdot</1> ja <3> yksityisyydensuojakäytännön</3>`
  },

  stream: {
    emotion_impressive: 'Vaikuttavaa',
    emotion_unimpressive: 'Ei vaikuttavaa',
    message_not_started: 'Tulossa pian',
    message_running: 'Live',
    message_processing:
      'Prosessoimme livelähetystä toistoa varten. Tarkista myöhemmin video ja jatka arvostelujen ja palautteen antamista'
  },

  tabs: {
    audience: 'Yleisö',
    course: 'Kurssin yleiskatsaus',
    details: 'Live tapahtuman tiedot',
    description: 'Kuvaus',
    host: 'Isäntä',
    lesson: 'Oppitunnin yliskatsaus',
    lessons: 'Oppitunnit',
    overview: 'Yleiskatsaus',
    page: 'Sivunrakentaja',
    publish: 'Julkaise',
    settings: 'Julkaise asetus',
    total_views: 'Näyttökerrat',
    live_participates: 'Live osallistujat',
    live_chats: 'Live Chatit',
    live_quiz: 'Live Kyselyt',
    trainer_rating: 'Kouluttajan taso',
    trainer_times: 'Kouluttajan ajat',
    courses_quizzes: 'Kurssin kyselyt',
    user_list: 'Käyttäjälista',
    discussion: 'Keskustelu',
    notes: 'Muistiinpanoni'
  },

  topics: {
    SALES_TRAINING: 'Kauppakoulutus',
    NEGOTIATION_TRAINING: 'Neuvottelukoulutus',
    CROSS_CULTURAL_AWARENESS: 'Kulttuurien välinen ymmärrys',
    NETWORKING_SKILLS: 'Verkostoitumistaidot',
    SOFTWARE_ARCHITECTURE: 'Ohjelmistoarkkitehtuuri',
    PROJECT_MANAGEMENT: 'Projektihallinta',
    DIGITAL_TRANSFORMATION: 'Digitaalinen muokkaus',
    IT_CONSULTING: 'IT konsultointi',
    MANAGEMENT_CONSULTING: 'Hallintokonsultointi',
    HR_CONSULTING: 'HR Konsultointi',
    INTERNET_OF_THINGS: 'Internet of Things (IoT)',
    CYBERSECURITY: 'Kyberturvallisuus',
    PRIVACY_AND_GDRP: 'Yksityisyys ja GDPR'
  },

  training: {
    title: 'Koulutus',
    title_assessment: 'Arvioinnit',
    subtitle: 'Kurssit ja livetapahtumat',
    enrolled_title: 'Osallistumani kurssit ja livetapahtumat',
    enrolled_subtitle: 'Kurssit ja Livetapahtumat, joihin olet osallistunut',
    enrolled_message:
      'Et ole tällä hetkellä osallistunut millekään kursseille tai tapahtumiin.',
    past_live_event_title: 'Menneet livetapahtumat',
    past_live_event_subTitle: 'Suoritetut livetapahtumat',
    past_live_event: 'Menneitä livetapahtumia ei ole.',
    recomended_title: 'Suositellut kurssit ja livetapahtumat',
    now_live_event_title: 'Nyt Live',
    now_live_event_subTitle: 'Tapahtumat, jotka ovat livenä pian',
    now_live_event: 'Tällä hetkellä ei ole livetapahtumia.',
    webinar_event_title: 'Webinaarikanava',
    webinar_event_subTitle: 'Suoritetut webinaarit',
    webinar_event: 'Tällä hetkellä ei ole webinaareja.',
    p2p_event_title: 'Valmennussessiot',
    p2p_event_subTitle: 'Suoritetut valmennussessiot',
    p2p_event: 'Tällä hetkellä ei ole valmennussessioita.',

    now_live_assessment_title: 'Nyt Live',
    now_live_assessment_subTitle:
      'Arvioinnit, jotka ovat livenä tai tulevat pian',
    now_live_assessment_message: 'Livearviointeja ei ole tällä hetkellä.',

    upcoming_assessment_title: 'Tulevat livearvioinnit',
    upcoming_assessment_subtitle: 'Tulevat livearvioinnit',
    upcoming_assessment_message:
      'Tulevia Livearviointeja ei ole tällä hetkellä..',

    past_live_assessment_title: 'Menneet livearvioinnit',
    past_live_assessment_subTitle: 'Suoritetut livearvioinnit',
    past_live_assessment_message: 'Menneitä livearviointeja ei ole.',

    /**
     * <0/> get index 0 of data from Trans component
     * exp -->
     * <Trans i18nKey='training:recomended_subtitle' >
     * <Navlink>{...something}</Navlink> --> is index 0 of Trans component
     * <h1>{...something}</h1> --> is index 1 of Trans component
     * </Trans>
     */
    recomended_subtitle:
      'Olemme kuratoineet kursseja ja livetapahtumia perustuen sinun <0><0/></0>',
    /**
     * and we also can get data from index to replace in recommended_subtitle by like above string.
     * for exp -->
     * at the end of the recomended_subtitle above will get data from index of component to display
     * <0><0/></0> mean get data index 0 of Trans component above = <Navlink> and <0/> get data index 0 from <Navlink> = {...something}
     */
    search: 'Etsi koulutus',
    search_assessment: 'Etsi arviointi',
    recomended_message:
      'Tällä hetkellä ei ole suositeltuja kursseja ja tapahtumia.'
  },

  warnings: {
    delete: 'Oletko varma?'
  },

  workshop: {
    title: 'Oma Workshop',
    subtitle: 'Luo kurssi tai isännöi oma livetapahtuma',
    new_course: 'Luo uusi kurssi',
    new_event: 'Luo uusi livetapahtuma',
    new_assessment: 'Luo uusi livearviointi',
    courses_title: 'Luodut kurssit ja livetapahtumat',
    courses_subtitle:
      'Muokkaa & Julkaise luomasi kurssi ja suunnittele livetapahtuma',
    tags_course: 'Kurssi',
    tags_live: 'Livetapahtuma',
    tags_assessment: 'Livearviointi'
  },

  help_center: {
    sidebar: {
      title: 'Miten voimme auttaa?',
      back_to: 'Etusivu'
    },
    menu: {
      help_center: 'Tukikeskus',
      whats_new: 'Uutiset',
      feedback: 'Palaute',
      feedback_title: 'Lähetä palautetta Sharelookille',
      terms_and_conditions: 'Käyttöehdot',
      privacy_policy: 'Yksityisyydensuojakäytäntö',
      contact_us: 'Ota yhteyttä'
    },
    get_started: {
      title: 'Aloita Sharelook',
      description: {
        main:
          'OLEMME INTEGROINEED LIVEVIDEON HELPOSTI KÄYTETTÄVÄÄN KURSSINRAKENTAJAAN',
        tagline:
          'ShareLookin patentoidulla livelähetysjärjestelmällä voit luoda tapahtumia, automatisoida oppimista ja maksimoida tiedon jakamisen.'
      }
    },
    whats_new: {
      title: 'Aloita share look',
      description: {
        main:
          'Tiesitkö, että Tarinankerrontatyylisen oppimisen luominen on nopeaa ja halpaa? Sinun kannattaa yhdistää ShareLook työkalut ja oikeat talentit. Voit kysyä meiltä ”MITEN”',
        tagline: ''
      }
    },
    create_workshop: 'Miten luoda Workshop',
    create_course: 'Miten luoda kurssi',
    create_user: 'Miten luoda käyttäjä',
    create_group: 'Miten luoda ryhmä',
    create_webinar: 'Miten luoda webinaari',
    create_live_event: 'Miten luoda livetapahtuma',
    create_live_assessment: 'Miten luoda livearviointi',
    create_live_on_mobile: 'Tee livenä mobiililaitteella',
    personalize_profile: 'Personalisoi profiili',
    manage_group: 'Hallitse ryhmää',
    report: 'Raportti',
    add_annotations: 'Miten lisätä ilmoitukset/Popupit',
    add_audio: 'Miten lisätä Audio',
    add_header_and_footer: 'Header & Footer lisääminen',
    add_image: 'Miten lisätä kuva',
    add_quiz_content: 'Miten lisätä kyselysisältö',
    add_text_content: 'Miten lisätä tekstisisältö',
    add_user: 'Miten lisätä käyttäjä',
    add_video: 'Miten lisätä video',
    clone_course: 'Miten kloonata kurssi',
    find_live_broadcast: 'Miten löytää livelähetys',
    contact_us: {
      title: 'Ota yhteyttä',
      subject_placeholder: 'Syötä aihe*',
      content_placeholder: 'Syötä viesti*',
      subject_required: '*Aihe vaaditaan',
      content_required: '*Viesti vaaditaan',
      submit: 'Lähetä',
      cancel: 'Peruuta',
      sent: 'Lähetetty'
    },
    feedback: {
      title: 'Lähetä palaute Sharelookille',
      attach_title: 'Liitä tiedosto',
      choose: 'Valitse tiedosto',
      detail: 'Tiedosto jaetaan tukitiimille',
      content_placeholder: 'Syötä viesti*',
      content_required: '*Viesti vaaditaan',
      submit: 'Lähetä',
      cancel: 'Peruuta',
      sent: 'Lähetetty'
    }
  },
  discussion: {
    join_discussion: 'Liity keskusteluun'
  },
  notes: {
    title: 'Muistiinpanoni',
    add_note: 'Lisää uusi muistiinpano'
  }
}
